import Vue from 'vue'
import api from '@/api_alv'
import i18n from '@/assets/i18n/i18n'
import { router } from '@/router.js'
import alvPlugin from '@/assets/helpers/alvPlugin'

const DIR = 'publishing/works'

const DEFAULT_WORK = {
    "id": 0,
    "alvId": "ALV000000000PW",
    "title": null,
    "domesticTitle": null,
    "gemaNumber": null,
    "registrationDate": null,
    "status": null,
    "composers": [],
    "publishers": [],
    "iwk": null, 
    "lastUpdated": null,
    "iceStatus": null, 
    "scorePrinting": null,
    "iswc": null,
    "seconds": null,
    "language": null,
    "catalogueNumber": null,
    "isrc": null,  
    "foreignWorkIds": null,
    "duration": null,
    "type": null,
    "notificationDate": null,
    "workPoints" : null,
    "notes": null,
    "pwrDate": null,
    "pwrDuration": null,
    "leadingPublisher": null, 
    "style": null, 
    "backCollection": "yes",
    "oldMrSplit": "currentDistribution",
    "freeRoleSplitMusic": null,
    "freeRoleSplitText" : null,
    "tags": null,
    "favourites": null,
    // Panels
    "alternativeTitles": [],
    "otherInterestedParties": [],
    "otherIds": [],
    "originalInterestedParties": [],
    "instrumentation": []
}

const DEFAULT_ALTERNATIVE_TITLES = {
    "id": 0,
    "title": null,
    "type": null
}

const DEFAULT_OTHER_PERSONS = {
    "id": 0,
    "name": null,
    "type": null
}

const DEFAULT_OTHER_IDS = {
    "id": 0,
    "sourceAlvId": null,
    "otherId": null,
    "country": null,
}

const DEFAULT_INSTRUMENTAION = {
    "id": 0,
    "title": null,
    "instruments": null,
    "musicians":null,
    "voices":null
}

const DEFAULT_ORIGINAL_SHARES = {
    "id": 0,
    "prPercent": null,
    "mrPercent": null,
    "mrSociety": null,
    "prSociety":null,
    "azEntity": null,
    "role": null,
    "pwr": [],
    "pmr": null,
    "position": null,
    "ipi": null,
    "shareType": null
}

const state = {
// List
    works: [],
    work: null,
    bulkEditConvertRoleToSharesReportCsv: null,
    workLoading: false,
    worksPagination: null,
    selectedWorks: [],
    isAllSelectedWorks: false,
    expandedWorks: [],
    selectedCwrSubmitterCode: null,
    selectedSpotifySetting: null,
    worksSideSortingOptions: {
        sortBy: ['title'],
        sortDesc: [false],
        mustSort: true
    },
//Share type
    workShareType: null,

// Filters
    worksSearch: "",
    selectedWorksQualityFilter: [],
    selectedWorksStatusFilter: [],
    noSharesCheckbox: ['role'],
    noSharesHomeSocietyCheckbox:[],
    showNoSharesDialog: false,
    showDistributionSearchDialog: false,

    distributionSearchDetails: {},
    distributionSearchDetailsTarget: [],
    distributionSearchDetailsFunction: [],
    distributionSearchDetailsStatus: [],
    distributionSearchDetailsFrom: null,
    distributionSearchDetailsTo: null,
    //Year of expiration
    showYearOfExpirationDialog: false,
    selectedYearOfExpiration: 0,
    //Find duplicates: which work id is compared and which works of a duplicate group are wanted
    showFindDuplicatesDialog: false,
    selectedDuplicatesIdType: 'workId',
    selectedDuplicatesScope: 'withStatus2',
    //Merge works: target work, what the merge would do and whether the user has confirmed the preview
    showMergeWorksDialog: false,
    mergeWorksTargetAlvId: null,
    mergeWorksSharesFromAlvId: null,
    mergeWorksPreview: null,
    mergeWorksResult: null,
    mergeWorksErrorMsg: null,
    mergeWorksIsLoading: false,
    mergeWorksIsConfirmed: false,

//Breadcrumbs
    selectedPublishingCompany:'',

// Actions (Buttons, Import, Export)
    selectedWorksAction: [],

    // Add Contracts
    contractsForWorksSearch: "",
    selectedContractsForWorks: [],
    totalContractsForWorksListed: "",
    totalContractsForWorksRecords: "",

    // Gema Soundfile
    showGemaSoundfileDialog: false,
    gemaSoundfileDialogApprovals: ["advertisement", "tvRadio", "online", "clubDisco"],

    // GEMA Repertoire (token based search) - result cache
    gemaRepertoireVersions: null,

    // Works Registration
    showWorksRegistrationDialog: false,
    worksRegistrationSelectedTarget: '',
    cwrSocietiesList: [],
    worksRegistrationDetailsCwrSubmitter: null,
    worksRegistrationDetailsCwrRecipient: null,
    worksRegistrationDetailsInterestedParties: 'no',
    worksRegistrationDetailsShareType: 'own',
    worksRegistrationDetailsPmr: 'no',
    worksRegistrationDetailsSelectedPublisherEntry: null,
    // Checkboxes IWA
    // worksRegistrationGemaIwaFirstCheckbox: [],
    // worksRegistrationGemaIwaSecondCheckbox: [],
    // worksRegistrationGemaIwaThirdCheckbox: [],
    // worksRegistrationGemaIwaFourthCheckbox: [],
    worksRegistrationGemaLoginToken: null,
    worksRegistrationDialogStepText: '',
    worksRegistrationDialogSuccessText: null,
    worksRegistrationDialogErrorText: null,
    worksRegistrationDialogShowLoginButton: true,
    worksRegistrationDialogDisableLoginButton: false,
    worksRegistrationDialogShowPreflightButton: false,
    worksRegistrationDialogDisablePreflightButton: false,
    worksRegistrationDialogShowSendButton: false,
    worksRegistrationDialogDisableSendButton: false,
    worksRegistrationDeaktivateForm: false,
    worksRegistrationDeaktivateLogin: false,
    worksRegistrationXmlFilePath: null,
    worksRegistrationPreflightPathCsv: null,
    worksRegistrationRegistrationErrorCsv: null,
    worksRegistrationRegistrationCsv: null,
    bulkEditCopySharesReportCsv: null,
    bulkEditFillOriginalSharesReportCsv: null,
    bulkEditFillOriginalSharesFailedCount: 0,
    bulkEditRemoveSEReportCsv: null,

    // Works Bulk Editing
    showWorksBulkEditingDialog: false,
    worksBulkEditingDetailsSourceShare: "fromGEMA",
    worksBulkEditingDetailsTargetShare: "toOwn",
    worksBulkEditingDetailsFillOriginalShares: "toRole",
    worksBulkEditingCopyMrToPrCheckbox: true,
    worksBulkEditingCombineCAAndECheckbox: false,
    worksBulkEditingPmrCollects100MRCheckbox: false,
    worksBulkEditingDetailsRemoveSEArray: [],
    worksBulkEditingDetailsRemoveSEField: null,
    worksBulkEditingDetailsRemoveSEShareType: 'own',
    worksBulkEditingDetailsSocietyOwnShares: 'none',
    
    worksBulkEditingDetailsTargetShareCombineE: 'intl',
    // Bulk Editing All
    bulkEditingAllWorks: false,
    bulkEditingStatusOfConvertRoleShares:"",
    bulkEditingShowConvertRoleSharesProgressBar:false,
    
    // Bulk Editing Confirmation Dialog
    showWorksBulkEditingConfirmDialog: false,
    worksBulkEditingActionToConfirm: null,

    // Test calculation GEMA
    testCalculationGemaDialog: false,
    testCalculationGemaForm: {},
    testCalculationGemaResult: [],
    testCalculationGemaResultErrorMessage: null,
    testCalculationGemaFormTypeOfRightsValues: [],
    testCalculationGemaFormBgValues: [],
    testCalculationGemaYktoOptions: [],
    testCalculationGemaFormCountry: null,

    // Test calculation SVD
    testCalculationSvdForm: {},
    testCalculationSvdDialog: false,
    testCalculationSvdResult: [],
    testCalculationSvdResultErrorMessage: null,
    testCalculationSvdCheckbox: [],

    // Test calculation C3
    testCalculationC3Form: {},
    testCalculationC3Dialog: false,
    testCalculationC3Result: [],
    testCalculationC3ResultErrorMessage: null,
    testCalculationC3FormTypeOfRightsValues: [],
    testCalculationC3SourceIdOptions: [],
    testCalculationC3RecipientIdOptions: null,
    // C3 form
    testCalculationC3DetailsAmount: null,
    testCalculationC3DetailsCollPercent: null,
    testCalculationC3DetailsCountry: null,
    testCalculationC3DetailsSourceId: null,
    testCalculationC3DetailsRecipientId: null,
    testCalculationC3DetailsRightsTypes: null,
    testCalculationC3DetailsCategory: null,
    testCalculationC3DetailsSubCategory: null,

    // Import
    showWorksImportDialog: false,
    worksImportUploadValue: 0,
    workImportTags: null,
    worksImportCwrType: 'ack',
    worksImportCwrSourceShareType: 'collection',
    worksImportCwrTargetShareType: 'intl',
    worksImportSelectedMapping: null,
    worksImportAllowedCheckbox: true,
    worksImportSearchWorkByTitleCheckbox: false,
    worksCwrPublisherSourceAzOptions: [],
    worksDetailsCwrPublisherSourceAz: null,
    worksImportCwrJsonDetailsSchema: 'cwr-json-v1.0',
    worksImportCwrJsonDetailsInclude: [],
    worksImportCwrJsonDetailsExclude: [],
    worksImportCwrJsonIncludeOptions: [],
    worksImportCwrJsonExcludeOptions: [],

    // Export
    showExportWorksDialog: false,
    exportAllWorks: false,
    exportWorksDetailsType: 'CWR',
    exportWorksExcelCheckbox: ["isIntl"],
    exportWorksCWRCheckbox: [],
    exportWorksTypesExcel: 'exportOpwTypes',
    exportWorksTypesCWR: 'exportOpwTypes',
    exportWorksIncludeOptions: [],
    exportWorksExcludeOptions: [],
    exportWorksDetailsInterestedPartiesExcel: 'no',
    exportWorksDetailsInterestedPartiesCWR: 'no',
    exportWorksDetailsCwrSubmitter: '',
    exportWorksDetailsJwrSubmitter: '',
    exportWorksDetailsCwrFileVersion: 'V22',
    exportWorksDetailsSchema: 'cwr-json-v1.0',
    exportWorksDetailsCwrRecipient: 0,
    exportWorksDetailsPseudoSlg: null,
    exportWorksDetailsInclude: [],
    exportWorksDetailsExclude: [],
    exportWorksErrorArray: [],
    exportWorksResultLink: null,
    exportWorksResultGi: null,
    exportWorksShowResult: false,
    exportWorksHasError: false,
    exportWorksDetailsMappingId: null,
    exportWorksDetailsMappingSource: null,
    exportWorksSlgContracts: [],
    exportWorksDetailsSelectedPublisherEntry: null,
    exportWorksDetailsShareType: 'own',
    exportPublisherEntries: [],

// Details (Edit Form + Read Only)
    defaultNewWork: DEFAULT_WORK,
    workDetails: {},
    workUniqueId: '',
    leadingPublishers: [],
    createNewWorkStatus: 'ghost',

    // DISTRIBUTION PANEL
    workDistributions: [],

    // WORK SHARES (not in use)
    workShares: [],

    // ALTERNATIVE TITLES Panel
    worksAlternativeTitles: [],
    selectedWorksAlternativeTitles: [],
    defaultWorksAlternativeTitles: DEFAULT_ALTERNATIVE_TITLES,
    worksAlternativeTitlesEditingDialogDetails: DEFAULT_ALTERNATIVE_TITLES,
    showWorksAlternativeTitlesEditingDialog: false,

    // OTHER PERSONS Panel
    worksOtherPersons: [],
    selectedWorksOtherPersons: [],
    defaultWorksOtherPersons: DEFAULT_OTHER_PERSONS,
    worksOtherPersonsEditingDialogDetails: DEFAULT_OTHER_PERSONS,
    showWorksOtherPersonsEditingDialog: false,

    // OTHER IDS Panel
    worksOtherIds: [],
    worksOtherIdsSearch: '',
    selectedWorksOtherIds: [],
    defaultWorksOtherIds: DEFAULT_OTHER_IDS,
    worksOtherIdsEditingDialogDetails: DEFAULT_OTHER_IDS,
    showWorksOtherIdsEditingDialog: false,
    azForOtherIdsSource: [],

    //INSTRUMENTATION Panel
    worksInstrumentation:[],
    selectedWorkInstrumentation:[],
    defaultWorksInstrumentation:DEFAULT_INSTRUMENTAION,
    worksInstrumentationEditingDialogDetails:DEFAULT_INSTRUMENTAION,
    showWorksInstrumentationEditingDialog:false,

    // ORIGINAL SHARES Panel
    worksOriginalShares: {},
    selectedWorksOriginalShares: [],
    showWorksOriginalSharesEditingDialog: false,
    defaultWorksOriginalShares: DEFAULT_ORIGINAL_SHARES,
    worksOriginalSharesEditingDialogDetails: DEFAULT_ORIGINAL_SHARES,
    worksOriginalSharesInterestedPartyOptions: [],

    //Sheets and Projects
    worksSheetsAndProjects:[],
    worksSheetsAndProjectsTotalListed:0,
    worksSheetsAndProjectsCurrentPage:1,
    worksSheetsAndProjectsTotalRecords:0,
    worksSheetsAndProjectsNumberOfPages:0,

    // Store for validation warnings and hints
    validationMessagesWork: [],

    // Title Assist Dialog
    showWorksTitleAssistDialog: false,
    worksTitleAssistSuggestions: { literal: [], romaji: '', transcreation: [] },
    worksTitleAssistDialogDetails: { titleAssistDraft: '', titleAssistSelection: null },
    worksTitleAssistDialogCheckbox: 'autoCapitalize',
    worksTitleAssistDialogCheckboxState: ['autoCapitalize'],
    worksTitleAssistLoading: false 

}

const getters = {
// List
    getWorks                                        (state) { return state.works },
    getSelectedWorks                                (state) { return state.selectedWorks },
    getIsAllSelectedWorks                           (state) { return state.isAllSelectedWorks },
    getExpandedWorks                                (state) { return state.expandedWorks },
    getSelectedCwrSubmitterCode                     (state) { return state.selectedCwrSubmitterCode },
    getSelectedSpotifySetting                       (state) { return state.selectedSpotifySetting },
    getWorksServerSideSortingOptions                (state) { return state.worksSideSortingOptions },
// Share type
    getWorkShareType                                   (state) { return state.workShareType },

// Filters
    getWorksSearch                                  (state) { return state.worksSearch },
    getSelectedWorksQualityFilter                   (state) { return state.selectedWorksQualityFilter },
    getSelectedWorksStatusFilter                    (state) { return state.selectedWorksStatusFilter },
    getNoSharesCheckbox                             (state) { return state.noSharesCheckbox}, 
    getNoSharesHomeSocietyCheckbox                  (state) { return state.noSharesHomeSocietyCheckbox}, 

    getDistributionSearchDetails                        (state) { return state.distributionSearchDetails },
    getDistributionSearchDetailsTarget                  (state) { return state.distributionSearchDetailsTarget },
    getDistributionSearchDetailsFunction                (state) { return state.distributionSearchDetailsFunction },
    getDistributionSearchDetailsStatus                  (state) { return state.distributionSearchDetailsStatus },
    getDistributionSearchDetailsFrom                    (state) { return state.distributionSearchDetailsFrom },
    getDistributionSearchDetailsTo                      (state) { return state.distributionSearchDetailsTo },
    
    //Year of Expiration
    getSelectedYearOfExpiration                         (state) { return state.selectedYearOfExpiration },

//Breadcrumbs
    getSelectedPublishingCompany                    (state) { return state.selectedPublishingCompany },

// Actions (Buttons, Import, Export)
    getSelectedWorksAction                          (state) { return state.selectedWorksAction },

    // GEMA Repertoire
    getGemaRepertoireVersions                       (state) { return state.gemaRepertoireVersions },

    // Add Contracts
    getContractsForWorksSearch                      (state) { return state.contractsForWorksSearch },
    getSelectedContractsForWorks                    (state) { return state.selectedContractsForWorks },
    getTotalContractsForWorksListed                 (state) { return state.totalContractsForWorksListed },
    getTotalContractsForWorksRecords                (state) { return state.totalContractsForWorksRecords },

    // Gema Soundfile
    getShowGemaSoundfileDialog                      (state) { return state.showGemaSoundfileDialog },
    getGemaSoundfileDialogApprovalsCheckbox         (state) { return state.gemaSoundfileDialogApprovals },  

    // Works Registration
    getShowWorksRegistrationDialog                  (state) { return state.showWorksRegistrationDialog },
    getWorksRegistrationDetailsTarget               (state) { return state.worksRegistrationSelectedTarget },
    getCwrSocietiesList                             (state) { return state.cwrSocietiesList },
    getWorksRegistrationDetailsCwrSubmitter         (state) { return state.worksRegistrationDetailsCwrSubmitter },
    getWorksRegistrationDetailsCwrRecipient         (state) { return state.worksRegistrationDetailsCwrRecipient },
    getWorksRegistrationDetailsInterestedParties    (state) { return state.worksRegistrationDetailsInterestedParties },
    getWorksRegistrationDetailsPmr                  (state) { return state.worksRegistrationDetailsPmr },
    getWorksRegistrationDetailsSelectedPublisherEntry(state) { return state.worksRegistrationDetailsSelectedPublisherEntry },
    getWorksRegistrationDetailsShareType            (state) { return state.worksRegistrationDetailsShareType },

    // Checkboxes IWA
    // getWorksRegistrationGemaIwaFirstCheckbox        (state) { return state.worksRegistrationGemaIwaFirstCheckbox },
    // getWorksRegistrationGemaIwaSecondCheckbox       (state) { return state.worksRegistrationGemaIwaSecondCheckbox },
    // getWorksRegistrationGemaIwaThirdCheckbox        (state) { return state.worksRegistrationGemaIwaThirdCheckbox },
    // getWorksRegistrationGemaIwaFourthCheckbox       (state) { return state.worksRegistrationGemaIwaFourthCheckbox },
    getWorksRegistrationGemaLoginToken              (state) { return state.worksRegistrationGemaLoginToken },
    getWorksRegistrationDialogStepText              (state) { return state.worksRegistrationDialogStepText },
    getWorksRegistrationDialogSuccessText           (state) { return state.worksRegistrationDialogSuccessText },
    getWorksRegistrationDialogErrorText             (state) { return state.worksRegistrationDialogErrorText },
    getWorksRegistrationDialogShowLoginButton       (state) { return state.worksRegistrationDialogShowLoginButton }, 
    getWorksRegistrationDialogDisableLoginButton    (state) { return state.worksRegistrationDialogDisableLoginButton },
    getWorksRegistrationDialogShowPreflightButton   (state) { return state.worksRegistrationDialogShowPreflightButton },
    getWorksRegistrationDialogDisablePreflightButton(state) { return state.worksRegistrationDialogDisablePreflightButton },
    getworksRegistrationDialogShowSendButton        (state) { return state.worksRegistrationDialogShowSendButton },
    getWorksRegistrationDialogDisableSendButton     (state) { return state.worksRegistrationDialogDisableSendButton },
    getWorksRegistrationDeaktivateForm              (state) { return state.worksRegistrationDeaktivateForm },
    getWorksRegistrationDeaktivateLogin             (state) { return state.worksRegistrationDeaktivateLogin },
    getWorksRegistrationXmlFilePath                 (state) { return state.worksRegistrationXmlFilePath },
    getWorksRegistrationPreflightPathCsv            (state) { return state.worksRegistrationPreflightPathCsv },
    getWorksRegistrationRegistrationErrorCsv        (state) { return state.worksRegistrationRegistrationErrorCsv },
    getWorksRegistrationRegistrationCsv             (state) { return state.worksRegistrationRegistrationCsv },
    getBulkEditCopySharesReportCsv                  (state) { return state.bulkEditCopySharesReportCsv },
    getBulkEditFillOriginalSharesReportCsv          (state) { return state.bulkEditFillOriginalSharesReportCsv },
    getBulkEditFillOriginalSharesFailedCount        (state) { return state.bulkEditFillOriginalSharesFailedCount },
    getBulkEditRemoveSEReportCsv                    (state) { return state.bulkEditRemoveSEReportCsv },

    // Works Bulk Editing
    getShowWorksBulkEditingDialog                   (state) { return state.showWorksBulkEditingDialog },
    getWorksBulkEditingDetailsSourceShare           (state) { return state.worksBulkEditingDetailsSourceShare },
    getWorksBulkEditingDetailsTargetShare           (state) { return state.worksBulkEditingDetailsTargetShare },
    getWorksBulkEditingDetailsFillOriginalShares    (state) { return state.worksBulkEditingDetailsFillOriginalShares },
    getWorksBulkEditingCopyMrToPrCheckbox           (state) { return state.worksBulkEditingCopyMrToPrCheckbox },
    getWorksBulkEditingCombineCAAndECheckbox        (state) { return state.worksBulkEditingCombineCAAndECheckbox },
    getWorksBulkEditingPmrCollects100MRCheckbox     (state) { return state.worksBulkEditingPmrCollects100MRCheckbox },
    getWorksBulkEditingDetailsRemoveSEArray         (state) { return state.worksBulkEditingDetailsRemoveSEArray },
    getWorksBulkEditingDetailsRemoveSEField         (state) { return state.worksBulkEditingDetailsRemoveSEField },
    getWorksBulkEditingDetailsRemoveSEShareType     (state) { return state.worksBulkEditingDetailsRemoveSEShareType },
    getWorksBulkEditingDetailsSocietyOwnShares      (state) { return state.worksBulkEditingDetailsSocietyOwnShares },

    getWorksBulkEditingDetailsTargetShareCombineE   (state) { return state.worksBulkEditingDetailsTargetShareCombineE },
    // Bulk Editing All
    getBulkEditingAllWorks                          (state) { return state.bulkEditingAllWorks },
    getBulkEditingStatusOfConvertRoleShares         (state) { return state.bulkEditingStatusOfConvertRoleShares },
    getBulkEditingShowConvertRoleSharesProgressBar  (state) { return state.bulkEditingShowConvertRoleSharesProgressBar },
    // Bulk Editing Confirmation Dialog
    getShowWorksBulkEditingConfirmDialog            (state) { return state.showWorksBulkEditingConfirmDialog },
    getWorksBulkEditingActionToConfirm              (state) { return state.worksBulkEditingActionToConfirm},

    // Test calculation GEMA
    getTestCalculationGemaDialog                    (state) { return state.testCalculationGemaDialog },
    getTestCalculationGemaForm                      (state) { return state.testCalculationGemaForm },
    getTestCalculationGemaResult                    (state) { return state.testCalculationGemaResult },
    getTestCalculationGemaResultErrorMessage        (state) { return state.testCalculationGemaResultErrorMessage },
    getTestCalculationGemaFormTypeOfRightsValues    (state) { return state.testCalculationGemaFormTypeOfRightsValues },
    getTestCalculationGemaYktoOptions               (state) { return state.testCalculationGemaYktoOptions },
    getTestCalculationGemaFormBgValues              (state) { return state.testCalculationGemaFormBgValues },
    getTestCalculationGemaDetailsAmount             (state) { return state.testCalculationGemaForm.amount },
    getTestCalculationGemaDetailsRights             (state) { return state.testCalculationGemaForm.rights },
    getTestCalculationGemaDetailsCountry            (state) { return state.testCalculationGemaForm.country },
    getTestCalculationGemaDetailsYkto               (state) { return state.testCalculationGemaForm.ykto },
    getTestCalculationGemaDetailsBg                 (state) { return state.testCalculationGemaForm.bg },
    getTestCalculationGemaDetailsHkto               (state) { return state.testCalculationGemaForm.hkto },
    getTestCalculationGemaDetailsGdfPercent         (state) { return state.testCalculationGemaForm.percent },
    getTestCalculationGemaDetailsUkto               (state) { return state.testCalculationGemaForm.ukto },

    // Test calculation SVD
    getTestCalculationSvdForm                       (state) { return state.testCalculationSvdForm },
    getTestCalculationSvdDialog                     (state) { return state.testCalculationSvdDialog },
    getTestCalculationSvdResult                     (state) { return state.testCalculationSvdResult },
    getTestCalculationSvdResultErrorMessage         (state) { return state.testCalculationSvdResultErrorMessage },
    getTestCalculationSvdFormTypeOfRightsValues     (state) { return state.testCalculationGemaFormTypeOfRightsValues },
    getTestCalculationSvdDetailsAtSource            (state) { return state.testCalculationSvdForm.amountAtSource },
    getTestCalculationSvdDetailsRights              (state) { return state.testCalculationSvdForm.rights },
    getTestCalculationSvdDetailsAmount              (state) { return state.testCalculationSvdForm.amount },
    getTestCalculationSvdDetailsSharePercent        (state) { return state.testCalculationSvdForm.percent },
    getTestCalculationSvdDetailsCountry             (state) { return state.testCalculationSvdForm.country },
    getTestCalculationSvdCheckbox                   (state) { return state.testCalculationSvdCheckbox },

    // Test calculation C3
    getTestCalculationC3Form                        (state) { return state.testCalculationC3Form },
    getTestCalculationC3Dialog                      (state) { return state.testCalculationC3Dialog },
    getTestCalculationC3Result                      (state) { return state.testCalculationC3Result },
    getTestCalculationC3ResultErrorMessage          (state) { return state.testCalculationC3ResultErrorMessage },
    getTestCalculationC3FormTypeOfRightsValues      (state) { return state.testCalculationC3FormTypeOfRightsValues },
    getTestCalculationC3SourceIdOptions             (state) { return state.testCalculationC3SourceIdOptions },
    getTestCalculationC3RecipientIdOptions          (state) { return state.testCalculationC3RecipientIdOptions },
    // Form C3
    getTestCalculationC3DetailsAmount               (state) { return state.testCalculationC3DetailsAmount },
    getTestCalculationC3DetailsCollPercent          (state) { return state.testCalculationC3DetailsCollPercent },
    getTestCalculationC3DetailsCountry              (state) { return state.testCalculationC3DetailsCountry },
    getTestCalculationC3DetailsSourceId             (state) { return state.testCalculationC3DetailsSourceId },
    getTestCalculationC3DetailsRecipientId          (state) { return state.testCalculationC3DetailsRecipientId },
    getTestCalculationC3DetailsRightsTypes          (state) { return state.testCalculationC3DetailsRightsTypes },
    getTestCalculationC3DetailsCategory             (state) { return state.testCalculationC3DetailsCategory },
    getTestCalculationC3DetailsSubCategory          (state) { return state.testCalculationC3DetailsSubCategory },

    // Import
    getShowWorksImportDialog                        (state) { return state.showWorksImportDialog },
    getWorksImportUploadValue                       (state) { return state.worksImportUploadValue },
    getWorkImportTags                               (state) { return state.workImportTags },
    getWorksDetailsImportCwrType                    (state) { return state.worksImportCwrType },
    getWorksDetailsImportCwrSourceShareType         (state) { return state.worksImportCwrSourceShareType },
    getWorksDetailsImportCwrTargetShareType         (state) { return state.worksImportCwrTargetShareType },
    getWorksDetailsImportSelectedMapping            (state) { return state.worksImportSelectedMapping },
    getWorksDetailsImportAllowedCheckbox            (state) { return state.worksImportAllowedCheckbox },   
    getWorksDetailsSearchWorkByTitleCheckbox        (state) { return state.worksImportSearchWorkByTitleCheckbox },   
    getWorksCwrPublisherSourceAzOptions             (state) { return state.worksCwrPublisherSourceAzOptions },
    getWorksDetailsCwrPublisherSourceAz             (state) { return state.worksDetailsCwrPublisherSourceAz},
    getWorksImportCwrJsonDetailsSchema              (state) { return state.worksImportCwrJsonDetailsSchema },
    getWorksImportCwrJsonDetailsInclude             (state) { return state.worksImportCwrJsonDetailsInclude },
    getWorksImportCwrJsonDetailsExclude             (state) { return state.worksImportCwrJsonDetailsExclude },
    getWorksImportCwrJsonIncludeOptions             (state) { return state.worksImportCwrJsonIncludeOptions },
    getWorksImportCwrJsonExcludeOptions             (state) { return state.worksImportCwrJsonExcludeOptions },

    // Export
    getShowExportWorksDialog                        (state) { return state.showExportWorksDialog },
    getExportAllWorks                               (state)                            { return state.exportAllWorks },
    getExportWorksDetailsType                       (state)                    { return state.exportWorksDetailsType },
    getExportWorksExcelCheckbox                     (state)                  { return state.exportWorksExcelCheckbox },
    getExportWorksCWRCheckbox                       (state)                    { return state.exportWorksCWRCheckbox },
    getExportWorksIncludeOptions                    (state)                 { return state.exportWorksIncludeOptions },
    getExportWorksExcludeOptions                    (state)                 { return state.exportWorksExcludeOptions },
    getExportWorksDetailsInterestedPartiesExcel     (state)  { return state.exportWorksDetailsInterestedPartiesExcel },
    getExportWorksDetailsInterestedPartiesCWR       (state)    { return state.exportWorksDetailsInterestedPartiesCWR },
    getExportWorksDetailsExportWorksTypesExcel      (state)   { return state.exportWorksTypesExcel },
    getExportWorksDetailsExportWorksTypesCWR        (state)     { return state.exportWorksTypesCWR },   
    getExportWorksDetailsCwrSubmitter               (state)            { return state.exportWorksDetailsCwrSubmitter },
    getExportWorksDetailsJwrSubmitter               (state)            { return state.exportWorksDetailsJwrSubmitter },
    getExportWorksDetailsCwrFileVersion             (state)          { return state.exportWorksDetailsCwrFileVersion },
    getExportWorksDetailsSchema                     (state)          { return state.exportWorksDetailsSchema },
    getExportWorksDetailsCwrRecipient               (state)            { return state.exportWorksDetailsCwrRecipient },
    getExportWorksDetailsInclude                    (state)                 { return state.exportWorksDetailsInclude },
    getExportWorksDetailsExclude                    (state)                 { return state.exportWorksDetailsExclude },
    getExportWorksErrorArray                        (state)                    { return state.exportWorksErrorArray },
    getExportWorksResultLink                        (state)                     { return state.exportWorksResultLink },
    getExportWorksResultGi                          (state)                       { return state.exportWorksResultGi },
    getExportWorksShowResult                        (state)                     { return state.exportWorksShowResult },
    getExportWorksHasError                          (state)                     { return state.exportWorksHasError },
    getExportWorksDetailsMappingId                  (state)               { return state.exportWorksDetailsMappingId },
    getExportWorksDetailsMappingSource              (state)           { return state.exportWorksDetailsMappingSource },
    getExportWorksSlgContracts                      (state)                   { return state.exportWorksSlgContracts },
    getExportWorksDetailsPseudoSlg                  (state)               { return state.exportWorksDetailsPseudoSlg },
    getExportWorksDetailsSelectedPublisherEntry     (state)  { return state.exportWorksDetailsSelectedPublisherEntry },
    getExportPublisherEntries                       (state)                    { return state.exportPublisherEntries },
    getExportWorksDetailsShareType                  (state)              { return state.exportWorksDetailsShareType },

// Details (Edit Form + Read Only)
    getDefaultNewWork(state) { return state.defaultNewWork },
    getWorksUniqueId(state) { return state.workUniqueId },
    getWorksDetails(state) { return state.workDetails },
    getLeadingPublishers(state) { return state.leadingPublishers },
    getWorkDetailsPwrDuration(state) { return state.workDetails.pwrDuration },
    getWorkDetailsPwrDate(state) { return state.workDetails.pwrDate },
    
    getCreateNewWorkStatus(state) { return state.createNewWorkStatus },
    // Edit Form Fields
    getWorkDetailsAlvId(state) { return state.workDetails.alvId },
    getWorkDetailsTitle(state) { return state.workDetails.title },
    getWorkDetailsDomesticTitle(state) { return state.workDetails.domesticTitle },
    getWorkDetailsSocietyWorkId(state) { return state.workDetails.gemaNumber },
    getWorkDetailsRegistrationDate(state) { return state.workDetails.registrationDate },
    getWorkDetailsStatus(state) { return state.workDetails.status },
    getWorkDetailsRegistrationId(state) { return state.workDetails.registrationId },
    getWorkDetailsIceWorkKey(state) { return state.workDetails.iwk },
    getWorkDetailsLastUpdated(state) { return state.workDetails.lastUpdated },   
    getWorkDetailsIceStatus(state) { return state.workDetails.iceStatus }, 
    getWorkDetailsScorePrinting(state) { return state.workDetails.scorePrinting },
    getWorkDetailsIswc(state) { return state.workDetails.iswc },    
    getWorkDetailsLanguage(state) { return state.workDetails.language },
    getWorkDetailsCatalogueNumber(state) { return state.workDetails.catalogueNumber },
    getWorkDetailsType(state) { return state.workDetails.type },
    
    getWorkDetailsIsrc(state) { 
        if(state.workDetails.isrc === undefined || state.workDetails.isrc === null) return null
        else return state.workDetails.isrc.manual
    },
    getWorkDetailsNotes(state) { return state.workDetails.notes },
    getWorkDetailsWorkPoints(state) { return state.workDetails.workPoints },
    getWorkDetailsNotificationDate(state) { return state.workDetails.notificationDate },
    getWorkDetailsForeignWorkIds(state) { return state.workDetails.foreignWorkIds },      
    getWorkDetailsDuration(state) { return state.workDetails.duration },
    getWorkDetailsStyle(state) { return state.workDetails.style },
    
    getWorkDetailsBackCollection(state) { return state.workDetails.backCollection },
    getWorkDetailsOldMrSplit(state) { return state.workDetails.oldMrSplit },
    getWorkDetailsTags(state) { return state.workDetails.tags },
    getWorkDetailsFavourites(state) { return state.workDetails.favourites },
    getWorkDetailsFreeRoleSplitMusic(state) { return state.workDetails.freeRoleSplitMusic },
    getWorkDetailsFreeRoleSplitText(state) { return state.workDetails.freeRoleSplitText },
    getWorkDetailsLeadingPublisher(state) { return state.workDetails.leadingPublisher },

    // DISTRIBUTION PANEL
    getWorkDistributions(state) { return state.workDetails.distributions },

    // WORK SHARES (not in use)
    getWorkShares(state) { return state.workShares },

    // ALTERNATIVE TITLES Panel
    getWorksAlternativeTitles(state) { return state.worksAlternativeTitles },
    getSelectedWorksAlternativeTitles(state) { return state.selectedWorksAlternativeTitles },
    getDefaultWorksAlternativeTitles(state) { return state.defaultWorksAlternativeTitles },
    // Editing Dialog
    getShowWorksAlternativeTitlesEditingDialog(state) { return state.showWorksAlternativeTitlesEditingDialog },
    getWorksAlternativeTitlesEditingDialogDetails(state) { return state.worksAlternativeTitlesEditingDialogDetails },
    getWorksAlternativeTitlesDetailsTitle(state) { return state.worksAlternativeTitlesEditingDialogDetails.title },
    getWorksAlternativeTitlesDetailsType(state) { return state.worksAlternativeTitlesEditingDialogDetails.type },

    // OTHER PERSONS Panel
    getWorksOtherPersons                                    (state) { return state.worksOtherPersons },
    getSelectedWorksOtherPersons                            (state) { return state.selectedWorksOtherPersons },
    getDefaultWorksOtherPersons                             (state) { return state.defaultWorksOtherPersons },

    // Editing Dialog
    getShowWorksOtherPersonsEditingDialog                   (state) { return state.showWorksOtherPersonsEditingDialog },
    getWorksOtherPersonsEditingDialogDetails                (state) { return state.worksOtherPersonsEditingDialogDetails },
    getWorksOtherPersonsDetailsName                         (state) { return state.worksOtherPersonsEditingDialogDetails.name },
    getWorksOtherPersonsDetailsType                         (state) { return state.worksOtherPersonsEditingDialogDetails.type },
    
    // OTHER IDS Panel
    getWorksOtherIds                                        (state) { return state.worksOtherIds },
    getWorksOtherIdsSearch                                  (state) { return state.worksOtherIdsSearch },
    getSelectedWorksOtherIds                                (state) { return state.selectedWorksOtherIds },
    getDefaultWorksOtherIds                                 (state) { return state.defaultWorksOtherIds },
    getAzForOtherIdsSource                                  (state) { return state.azForOtherIdsSource },
    
    // OTHER IDS Editing Dialog
    getShowWorksOtherIdsEditingDialog                       (state) { return state.showWorksOtherIdsEditingDialog },
    getWorksOtherIdsEditingDialogDetails                    (state) { return state.worksOtherIdsEditingDialogDetails },
    getWorksOtherIdsDetailsSourceAlvId                      (state) { return state.worksOtherIdsEditingDialogDetails.sourceAlvId },
    getWorksOtherIdsDetailsOtherId                          (state) { return state.worksOtherIdsEditingDialogDetails.otherId },
    getWorksOtherIdsDetailsCountry                          (state) { return state.worksOtherIdsEditingDialogDetails.country },

    // INSTRUMENTATION Panel
    getWorksInstrumentation(state) { return state.worksInstrumentation },
    getSelectedWorksInstrumentation(state) { return state.selectedWorkInstrumentation },
    getDefaultWorksInstrumentation(state) { return state.defaultWorksInstrumentation },
    //Editing dialog
    getWorksInstrumentationEditingDialogDetails(state) { return state.worksInstrumentationEditingDialogDetails },
    getShowWorksInstrumentationEditingDialog(state) { return state.showWorksInstrumentationEditingDialog },
    getWorksInstrumentationDetailsTitle(state) { return state.worksInstrumentationEditingDialogDetails.title },
    getWorksInstrumentationDetailsInstruments(state) { return state.worksInstrumentationEditingDialogDetails.instruments },
    getWorksInstrumentationDetailsMusicians(state) { return state.worksInstrumentationEditingDialogDetails.musicians },
    getWorksInstrumentationDetailsVoices(state) { return state.worksInstrumentationEditingDialogDetails.voices },

    // ORIGINAL SHARES Panel
    getWorksOriginalShares(state) { return state.worksOriginalShares },
    getSelectedWorksOriginalShares(state) { return state.selectedWorksOriginalShares },
    // Editing Dialog
    getShowNoSharesDialog                           (state) {return state.showNoSharesDialog},
    getShowDistributionSearchDialog                 (state) {return state.showDistributionSearchDialog},
    getShowWorksOriginalSharesEditingDialog         (state) { return state.showWorksOriginalSharesEditingDialog },
    getDefaultWorksOriginalShares                   (state) { return state.defaultWorksOriginalShares },
    getWorksOriginalSharesEditingDialogDetails      (state) { return state.worksOriginalSharesEditingDialogDetails },
    getWorksOriginalSharesDetailsPrPercent          (state) { return state.worksOriginalSharesEditingDialogDetails.prPercent },
    getWorksOriginalSharesDetailsMrPercent          (state) { return state.worksOriginalSharesEditingDialogDetails.mrPercent },
    getWorksOriginalSharesDetailsRole               (state) { return state.worksOriginalSharesEditingDialogDetails.role },
    getWorksOriginalSharesDetailsPwr                (state) { return state.worksOriginalSharesEditingDialogDetails.pwr },
    getWorksOriginalSharesDetailsPmr                (state) { return state.worksOriginalSharesEditingDialogDetails.pmr },
    getWorksOriginalSharesDetailsPrSociety          (state) { return state.worksOriginalSharesEditingDialogDetails.prSociety },
    getWorksOriginalSharesDetailsMrSociety          (state) { return state.worksOriginalSharesEditingDialogDetails.mrSociety },
    getWorksOriginalSharesDetailsInterestedParty    (state) { return state.worksOriginalSharesEditingDialogDetails.azEntity },
    getWorksOriginalSharesDetailsShareType          (state) { return state.worksOriginalSharesEditingDialogDetails.shareType },
    getWorksOriginalSharesInterestedPartyOptions    (state) { return state.worksOriginalSharesInterestedPartyOptions },
    getShowYearOfExpirationDialog                   (state) { return state.showYearOfExpirationDialog },
    getShowFindDuplicatesDialog                     (state) { return state.showFindDuplicatesDialog },
    getSelectedDuplicatesIdType                     (state) { return state.selectedDuplicatesIdType },
    getSelectedDuplicatesScope                      (state) { return state.selectedDuplicatesScope },
    getShowMergeWorksDialog                         (state) { return state.showMergeWorksDialog },
    getMergeWorksTargetAlvId                        (state) { return state.mergeWorksTargetAlvId },
    getMergeWorksSharesFromAlvId                    (state) { return state.mergeWorksSharesFromAlvId },
    getMergeWorksPreview                            (state) { return state.mergeWorksPreview },
    getMergeWorksResult                             (state) { return state.mergeWorksResult },
    getMergeWorksErrorMsg                           (state) { return state.mergeWorksErrorMsg },
    getMergeWorksIsLoading                          (state) { return state.mergeWorksIsLoading },
    getMergeWorksIsConfirmed                        (state) { return state.mergeWorksIsConfirmed },
    
    //Sheets and Projects
    getWorksSheetsAndProjects                       (state) { return state.worksSheetsAndProjects },
    getWorksSheetsAndProjectsTotalListed            (state) { return state.worksSheetsAndProjectsTotalListed },
    getWorksSheetsAndProjectsCurrentPage            (state) { return state.worksSheetsAndProjectsCurrentPage },
    getWorksSheetsAndProjectsTotalRecords           (state) { return state.worksSheetsAndProjectsTotalRecords },
    getWorksSheetsAndProjectsNumberOfPages          (state) { return state.worksSheetsAndProjectsNumberOfPages },

    getValidationMessagesWork                       (state) { return state.validationMessagesWork },
    getBulkEditConvertRoleToSharesReportCsv:    state => state.bulkEditConvertRoleToSharesReportCsv,
    getWork:                                    state => state.work,
    getWorkLoading:                             state => state.workLoading,
    // Title Assist Dialog
    getWorksTitleAssistDialog:                  state => state.showWorksTitleAssistDialog,
    getWorksTitleAssistSuggestions:             state => state.worksTitleAssistSuggestions,
    getWorksTitleAssistDialogDetails:           state => state.worksTitleAssistDialogDetails,
    getWorksTitleAssistDialogDetailsTitleAssistDraft(state) { return state.worksTitleAssistDialogDetails.titleAssistDraft },
    getWorksTitleAssistDialogDetailsTitleAssistSelection(state) { return state.worksTitleAssistDialogDetails.titleAssistSelection },
    getWorksTitleAssistDialogCheckbox:          state => state.worksTitleAssistDialogCheckboxState,
    getWorksTitleAssistDraft:                   (state, getters) => getters.getWorksTitleAssistDialogDetailsTitleAssistDraft,
    getWorksTitleAssistLoading:                 state => state.worksTitleAssistLoading,
}

const mutations = {
// List
    setWorks:                               (state, worksFromDB) => { state.works = worksFromDB },
    setSelectedWorks:                       (state, selectedWorks) => { state.selectedWorks = selectedWorks },
    setIsAllSelectedWorks:                  (state, isSelected) => { state.isAllSelectedWorks = isSelected },
    setExpandedWorks:                       (state, work) => { 
                                            state.expandedWorks = [work]
                                                // if(Object.keys(work).length === 0) state.expandedWorks = []
                                                // else state.expandedWorks.push(work) 
        	                                },
    setSelectedCwrSubmitterCode:            (state, item) => { state.selectedCwrSubmitterCode = item},
    setSelectedSpotifySetting:              (state, item) => { state.selectedSpotifySetting = item},
    setWorksServerSideSortingOptions:       (state, value) => { state.worksSideSortingOptions = value},     
// Share Type
    setWorkShareType:                       (state, value) => { state.workShareType = value},     

// Filters
    setWorksSearch: (state, search) => { state.worksSearch = search },
    setSelectedWorksQualityFilter: (state, option) => { state.selectedWorksQualityFilter = option },
    setSelectedWorksStatusFilter: (state, option) => { state.selectedWorksStatusFilter = option },
    setNoSharesCheckbox: (state, option) => { state.noSharesCheckbox = option},
    setNoSharesHomeSocietyCheckbox: (state, option) => { state.noSharesHomeSocietyCheckbox = option},

    setDistributionSearchDetailsTarget:                     (state, value) => { state.distributionSearchDetailsTarget = value},
    setDistributionSearchDetailsFunction:                   (state, value) => { state.distributionSearchDetailsFunction = value},
    setDistributionSearchDetailsStatus:                     (state, value) => { state.distributionSearchDetailsStatus = value },
    setDistributionSearchDetailsFrom:                       (state, value) => { state.distributionSearchDetailsFrom = value},
    setDistributionSearchDetailsTo:                         (state, value) => { state.distributionSearchDetailsTo = value},
    //Year of expiration
    setSelectedYearOfExpiration:                            (state, value) => {state.selectedYearOfExpiration = value},

    //Breadcrumbs
    setSelectedPublishingCompany:                           (state,value) => { state.selectedPublishingCompany = value },

// Actions (Buttons, Import, Export)
    setSelectedWorksAction:                                 (state, selectedWorksAction) => { state.selectedWorksAction = selectedWorksAction },

    // Add Works
    setContractsForWorksSearch: (state, search) => { state.contractsForWorksSearch = search }, 
    setSelectedContractsForWorks: (state, selectedContracts) => { state.selectedContractsForWorks = selectedContracts },
    setTotalContractsForWorksListed(state, value) { state.totalContractsForWorksListed = value },
    setTotalContractsForWorksRecords(state, value) { state.totalContractsForWorksRecords = value },

    // Gema Soundfile
    setShowGemaSoundfileDialog: (state, showGemaSoundfileDialog) => { state.showGemaSoundfileDialog = showGemaSoundfileDialog },
    setGemaSoundfileDialogApprovalsCheckbox: (state, value) => { state.gemaSoundfileDialogApprovals = value },

    // GEMA Repertoire
    setGemaRepertoireVersions: (state, value) => { state.gemaRepertoireVersions = value },

    // Test calculation gema
    setTestCalculationGemaForm: (state, data) => { state.testCalculationGemaForm = data },
    setTestCalculationGemaDialog: (state, show) => { state.testCalculationGemaDialog = show },
    setTestCalculationGemaResult: (state, result) => { state.testCalculationGemaResult = result },
    setTestCalculationGemaResultErrorMessage: (state, msg) => { state.testCalculationGemaResultErrorMessage = msg },
    setTestCalculationGemaFormTypeOfRightsValues: (state, options) => { state.testCalculationGemaFormTypeOfRightsValues = options },
    setTestCalculationGemaFormBgValues: (state, options) => { state.testCalculationGemaFormBgValues = options },
    setTestCalculationGemaYktoOptions: (state, options) => { state.testCalculationGemaYktoOptions = options },
    setTestCalculationGemaDetailsAmount: (state, amount) => { state.testCalculationGemaForm.amount = amount },
    setTestCalculationGemaDetailsRights: (state, rights) => { state.testCalculationGemaForm.rights = rights },
    setTestCalculationGemaDetailsCountry: (state, country) => { state.testCalculationGemaForm.country = country },
    setTestCalculationGemaDetailsYkto: (state, kto) => { state.testCalculationGemaForm.ykto = kto },
    setTestCalculationGemaDetailsBg: (state, bg) => { state.testCalculationGemaForm.bg = bg },
    setTestCalculationGemaDetailsHkto: (state, kto) => { state.testCalculationGemaForm.hkto = kto },
    setTestCalculationGemaDetailsGdfPercent: (state, percent) => { state.testCalculationGemaForm.percent = percent },
    setTestCalculationGemaDetailsUkto: (state, kto) => { state.testCalculationGemaForm.ukto = kto },

    // Test calculation SVD
    setTestCalculationSvdForm:                              (state, data) => { state.testCalculationSvdForm = data },
    setTestCalculationSvdDialog:                            (state, show) => { state.testCalculationSvdDialog = show },
    setTestCalculationSvdResult:                            (state, result) => { state.testCalculationSvdResult = result },
    setTestCalculationSvdResultErrorMessage:                (state, msg) => { state.testCalculationSvdResultErrorMessage = msg },    
    setTestCalculationSvdFormTypeOfRightsValues:            (state, options) => { state.testCalculationGemaFormTypeOfRightsValues = options },
    setTestCalculationSvdDetailsAtSource:                   (state, amount) => { state.testCalculationSvdForm.amountAtSource = amount },
    setTestCalculationSvdDetailsRights:                     (state, right) => { state.testCalculationSvdForm.rights = right },
    setTestCalculationSvdDetailsAmount:                     (state, amount) => { state.testCalculationSvdForm.amount = amount },
    setTestCalculationSvdDetailsSharePercent:               (state, percent) => { state.testCalculationSvdForm.percent = percent },
    setTestCalculationSvdDetailsCountry:                    (state, country) => { state.testCalculationSvdForm.country = country },
    setTestCalculationSvdCheckbox:                          (state, value) => { state.testCalculationSvdCheckbox = value },

    // Test calculation C3
    setTestCalculationC3Form:                               (state, value) => { state.testCalculationC3Form = value },
    setTestCalculationC3Dialog:                             (state, value) => { state.testCalculationC3Dialog = value },
    setTestCalculationC3Result:                             (state, value) => { state.testCalculationC3Result = value },
    setTestCalculationC3ResultErrorMessage:                 (state, value) => { state.testCalculationC3ResultErrorMessage = value },    
    setTestCalculationC3FormTypeOfRightsValues:             (state, value) => { state.testCalculationC3FormTypeOfRightsValues = value },
    setTestCalculationC3SourceIdOptions:                    (state, value) => { state.testCalculationC3SourceIdOptions = value },
    setTestCalculationC3RecipientIdOptions:                 (state, value) => { state.testCalculationC3RecipientIdOptions = value },
    // C3 Form
    setTestCalculationC3DetailsAmount:                      (state, value) => { state.testCalculationC3DetailsAmount = value },
    setTestCalculationC3DetailsCollPercent:                 (state, value) => { state.testCalculationC3DetailsCollPercent = value },
    setTestCalculationC3DetailsCountry:                     (state, value) => { state.testCalculationC3DetailsCountry = value },
    setTestCalculationC3DetailsSourceId:                    (state, value) => { state.testCalculationC3DetailsSourceId = value },
    setTestCalculationC3DetailsRecipientId:                 (state, value) => { state.testCalculationC3DetailsRecipientId = value },
    setTestCalculationC3DetailsRightsTypes:                 (state, value) => { state.testCalculationC3DetailsRightsTypes = value },
    setTestCalculationC3DetailsCategory:                    (state, value) => { state.testCalculationC3DetailsCategory = value },
    setTestCalculationC3DetailsSubCategory:                 (state, value) => { state.testCalculationC3DetailsSubCategory = value },


    // Action > Work Registration
    setShowWorksRegistrationDialog:                     (state, item) => { state.showWorksRegistrationDialog = item },
    setWorksRegistrationDetailsTarget:                  (state, item) => { state.worksRegistrationSelectedTarget = item },
    setCwrSocietiesList:                                (state, list) => { state.cwrSocietiesList = list },
    setWorksRegistrationDetailsCwrSubmitter:            (state, value) => { state.worksRegistrationDetailsCwrSubmitter = value },
    setWorksRegistrationDetailsCwrRecipient:            (state, value) => { state.worksRegistrationDetailsCwrRecipient = value },
    setWorksRegistrationDetailsInterestedParties:       (state, value) => { state.worksRegistrationDetailsInterestedParties = value },
    setWorksRegistrationDetailsPmr:                     (state, value) => { state.worksRegistrationDetailsPmr = value },
    setWorksRegistrationDetailsSelectedPublisherEntry:  (state, value) => { state.worksRegistrationDetailsSelectedPublisherEntry = value },
    setWorksRegistrationDetailsShareType:               (state, value) => { state.worksRegistrationDetailsShareType = value },
    
    // Checkboxes IWA
    // setWorksRegistrationGemaIwaFirstCheckbox:           (state, item) => { state.worksRegistrationGemaIwaFirstCheckbox = item },
    // setWorksRegistrationGemaIwaSecondCheckbox:          (state, item) => { state.worksRegistrationGemaIwaSecondCheckbox = item },
    // setWorksRegistrationGemaIwaThirdCheckbox:           (state, item) => { state.worksRegistrationGemaIwaThirdCheckbox = item },
    // setWorksRegistrationGemaIwaFourthCheckbox:          (state, item) => { state.worksRegistrationGemaIwaFourthCheckbox = item },
    setWorksRegistrationGemaLoginToken:                 (state, token) => { state.worksRegistrationGemaLoginToken = token },
    setWorksRegistrationDialogStepText:                 (state, text) => { state.worksRegistrationDialogStepText = text },
    setWorksRegistrationDialogSuccessText:              (state, text) => { state.worksRegistrationDialogSuccessText = text },
    setWorksRegistrationDialogErrorText:                (state, text) => { state.worksRegistrationDialogErrorText = text },
    setWorksRegistrationDialogShowLoginButton:          (state, show) => { state.worksRegistrationDialogShowLoginButton = show },
    setWorksRegistrationDialogDisableLoginButton:       (state, bool) => { state.worksRegistrationDialogDisableLoginButton = bool },
    setWorksRegistrationDialogShowPreflightButton:      (state, bool) => { state.worksRegistrationDialogShowPreflightButton = bool },
    setWorksRegistrationDialogDisablePreflightButton:   (state, bool) => { state.worksRegistrationDialogDisablePreflightButton = bool },
    setWorksRegistrationDialogShowSendButton:           (state, show) => { state.worksRegistrationDialogShowSendButton = show },
    setWorksRegistrationDialogDisableSendButton:        (state, bool) => { state.worksRegistrationDialogDisableSendButton = bool },
    setWorksRegistrationDeaktivateForm:                 (state, bool) => { state.worksRegistrationDeaktivateForm = bool },
    setWorksRegistrationDeaktivateLogin:                (state, bool) => { state.worksRegistrationDeaktivateLogin = bool },
    setWorksRegistrationXmlFilePath:                    (state, path) => { state.worksRegistrationXmlFilePath = path },
    setWorksRegistrationPreflightPathCsv:               (state, path) => { state.worksRegistrationPreflightPathCsv = path },
    setWorksRegistrationRegistrationErrorCsv:           (state, path) => { state.worksRegistrationRegistrationErrorCsv = path },
    setWorksRegistrationRegistrationCsv:                (state, path) => { state.worksRegistrationRegistrationCsv = path },
    setBulkEditCopySharesReportCsv:                     (state, path) => { state.bulkEditCopySharesReportCsv = path },
    setBulkEditFillOriginalSharesReportCsv:             (state, path) => { state.bulkEditFillOriginalSharesReportCsv = path },
    setBulkEditFillOriginalSharesFailedCount:           (state, count) => { state.bulkEditFillOriginalSharesFailedCount = count },
    setBulkEditRemoveSEReportCsv:                       (state, path) => { state.bulkEditRemoveSEReportCsv = path },

    // Works Bulk Editing
    setShowWorksBulkEditingDialog:                      (state, item) => { state.showWorksBulkEditingDialog = item },
    // Bulk Editing All
    setBulkEditingAllWorks:                             (state, item) => { state.bulkEditingAllWorks = item },
    setBulkEditingStatusOfConvertRoleShares:            (state, status) => { state.bulkEditingStatusOfConvertRoleShares = status },
    setBulkEditingShowConvertRoleSharesProgressBar:     (state, show) => { state.bulkEditingShowConvertRoleSharesProgressBar = show },
    // Bulk Editing Confirmation Dialog
    setShowWorksBulkEditingConfirmDialog:               (state, value) => { state.showWorksBulkEditingConfirmDialog = value},
    setWorksBulkEditingActionToConfirm:                 (state, value) => { state.worksBulkEditingActionToConfirm = value },

    // Copy Shares (bulk editing)
    setWorksBulkEditingDetailsSourceShare:              (state, item) => { state.worksBulkEditingDetailsSourceShare = item },
    setWorksBulkEditingDetailsTargetShare:              (state, item) => { state.worksBulkEditingDetailsTargetShare = item },
    // Fill Original shares
    setWorksBulkEditingDetailsFillOriginalShares:       (state, item) => { state.worksBulkEditingDetailsFillOriginalShares = item },
    setWorksBulkEditingCopyMrToPrCheckbox:              (state, value) => { state.worksBulkEditingCopyMrToPrCheckbox = value },
    setWorksBulkEditingCombineCAAndECheckbox:           (state, value) => { state.worksBulkEditingCombineCAAndECheckbox = value },
    setWorksBulkEditingPmrCollects100MRCheckbox:        (state, value) => { state.worksBulkEditingPmrCollects100MRCheckbox = value },
    // Remove SE list of subpublishers (bulk editing)
    setWorksBulkEditingDetailsRemoveSEArray:                (state, value) => { state.worksBulkEditingDetailsRemoveSEArray = value },
    setWorksBulkEditingDetailsRemoveSEField:                (state, value) => { state.worksBulkEditingDetailsRemoveSEField = value },
    setWorksBulkEditingDetailsRemoveSEShareType:            (state, value) => { state.worksBulkEditingDetailsRemoveSEShareType = value },
    setWorksBulkEditingDetailsSocietyOwnShares:             (state, value) => { state.worksBulkEditingDetailsSocietyOwnShares = value },
    // Combine E (bulk editing)
    setWorksBulkEditingDetailsTargetShareCombineE:      (state, value) => { state.worksBulkEditingDetailsTargetShareCombineE = value },

    // Import
    setShowWorksImportDialog:                               (state, value) => { state.showWorksImportDialog = value },
    setWorksImportUploadValue:                              (state, value) => { state.worksImportUploadValue = value },
    setWorkImportTags:                                      (state, value) => { state.workImportTags = value },
    setWorksDetailsImportCwrType:                           (state, value) => { state.worksImportCwrType = value },
    setWorksDetailsImportCwrSourceShareType:                (state, value) => { state.worksImportCwrSourceShareType = value },
    setWorksDetailsImportCwrTargetShareType:                (state, value) => { state.worksImportCwrTargetShareType = value },
    setWorksDetailsImportSelectedMapping:                   (state, value) => { state.worksImportSelectedMapping = value },
    setWorksDetailsImportAllowedCheckbox:                   (state, value) => { state.worksImportAllowedCheckbox = value },
    setWorksDetailsSearchWorkByTitleCheckbox:               (state, value) => { state.worksImportSearchWorkByTitleCheckbox = value },
    setWorksCwrPublisherSourceAzOptions:                    (state, value) => { state.worksCwrPublisherSourceAzOptions = value},
    setWorksDetailsCwrPublisherSourceAz:                    (state, value) => { state.worksDetailsCwrPublisherSourceAz = value},
    setWorksImportCwrJsonDetailsSchema:                     (state, value) => { state.worksImportCwrJsonDetailsSchema = value },
    setWorksImportCwrJsonDetailsInclude:                    (state, value) => { state.worksImportCwrJsonDetailsInclude = value },
    setWorksImportCwrJsonDetailsExclude:                    (state, value) => { state.worksImportCwrJsonDetailsExclude = value },
    setWorksImportCwrJsonIncludeOptions:                    (state, value) => { state.worksImportCwrJsonIncludeOptions = value },
    setWorksImportCwrJsonExcludeOptions:                    (state, value) => { state.worksImportCwrJsonExcludeOptions = value },

    // Export
    setShowExportWorksDialog:                               (state, value) => { state.showExportWorksDialog = value },
    setExportAllWorks:                                      (state, value) => { state.exportAllWorks = value },
    setExportWorksDetailsType:                              (state, value) => { state.exportWorksDetailsType = value },
    setExportWorksExcelCheckbox:                            (state, value) => { state.exportWorksExcelCheckbox = value },
    setExportWorksCWRCheckbox:                              (state, value) => { state.exportWorksCWRCheckbox = value },
    setExportWorksDetailsExportWorksTypesExcel:             (state, value) => { state.exportWorksTypesExcel = value },
    setExportWorksDetailsExportWorksTypesCWR:               (state, value) => { state.exportWorksTypesCWR = value },
    setExportWorksIncludeOptions:                           (state, value) => { state.exportWorksIncludeOptions = value },
    setExportWorksExcludeOptions:                           (state, value) => { state.exportWorksExcludeOptions = value },
    setExportWorksDetailsInterestedPartiesExcel:            (state, value) => { state.exportWorksDetailsInterestedPartiesExcel = value },
    setExportWorksDetailsInterestedPartiesCWR:              (state, value) => { state.exportWorksDetailsInterestedPartiesCWR = value },
    setExportWorksDetailsCwrSubmitter:                      (state, value) => { state.exportWorksDetailsCwrSubmitter = value },
    setExportWorksDetailsJwrSubmitter:                      (state, value) => { state.exportWorksDetailsJwrSubmitter = value },
    setExportWorksDetailsCwrFileVersion:                    (state, value) => { state.exportWorksDetailsCwrFileVersion = value },
    setExportWorksDetailsSchema:                            (state, value) => { state.exportWorksDetailsSchema = value },
    setExportWorksDetailsCwrRecipient:                      (state, value) => { state.exportWorksDetailsCwrRecipient = value },
    setExportWorksDetailsInclude:                           (state, value) => { state.exportWorksDetailsInclude = value },
    setExportWorksDetailsExclude:                           (state, value) => { state.exportWorksDetailsExclude = value },
    setExportWorksErrorArray:                               (state, value) => { state.exportWorksErrorArray = value },
    setExportWorksResultLink:                               (state, value) => { state.exportWorksResultLink = value },
    setExportWorksResultGi:                                 (state, value) => { state.exportWorksResultGi = value },
    setExportWorksShowResult:                               (state, value) => { state.exportWorksShowResult = value },
    setExportWorksHasError:                                 (state, value) => { state.exportWorksHasError = value },
    setExportWorksSlgContracts:                             (state, value) => { state.exportWorksSlgContracts = value },
    setExportWorksDetailsPseudoSlg:                         (state, value) => { state.exportWorksDetailsPseudoSlg = value },
    setExportWorksDetailsMappingId:                         (state, value) => { state.exportWorksDetailsMappingId = value },
    setExportWorksDetailsMappingSource:                     (state, value) => { state.exportWorksDetailsMappingSource = value },
    setExportWorksDetailsSelectedPublisherEntry:            (state, value) => { state.exportWorksDetailsSelectedPublisherEntry = value },
    setExportPublisherEntries:                              (state, value) => { state.exportPublisherEntries = value },
    setExportWorksDetailsShareType:                         (state, value) => { state.exportWorksDetailsShareType = value },

// Details (Edit Form + Read Only)  
    setDefaultNewWork: (state) => { state.defaultNewWork = DEFAULT_WORK },
    setWorksUniqueId: (state, id) => { state.workUniqueId = id },
    setWorksDetails: (state, details) => { state.workDetails = details },
    setLeadingPublishers: (state, publishers) => { state.leadingPublishers = publishers },
    setCreateNewWorkStatus: (state, status) => { state.createNewWorkStatus = status },
    // Edit Form Fields
    setWorkDetailsPwrDate: (state, value) => { state.workDetails.pwrDate = value },
    setWorkDetailsPwrDuration: (state, value) => { state.workDetails.pwrDuration = value },
    setWorkDetailsAlvId: (state, id) => { state.workDetails = id },
    setWorkDetailsTitle: (state, title) => { state.workDetails.title = title },
    setWorkDetailsDomesticTitle: (state, title) => { state.workDetails.domesticTitle = title },
    setWorkDetailsSocietyWorkId: (state, id) => { state.workDetails.gemaNumber = id },
    setWorkDetailsRegistrationDate: (state, date) => { state.workDetails.registrationDate = date },
    setWorkDetailsStatus: (state, status) => { state.workDetails.status = status },
    setWorkDetailsIceWorkKey: (state, key) => { state.workDetails.iwk = key },
    setWorkDetailsLastUpdated: (state, date) => { state.workDetails.lastUpdated = date },
    setWorkDetailsIceStatus: (state, status) => { state.workDetails.iceStatus = status },
    setWorkDetailsScorePrinting: (state, printing) => { state.workDetails.scorePrinting = printing },
    setWorkDetailsIswc: (state, iswc) => { state.workDetails.iswc = iswc },
    setWorkDetailsLanguage: (state, lang) => { state.workDetails.language = lang },
    setWorkDetailsCatalogueNumber: (state, number ) => { state.workDetails.catalogueNumber = number },
    setWorkDetailsType: (state, type) => { state.workDetails.type = type },
    setWorkDetailsIsrc: (state, isrc) => { state.workDetails.isrc = { 'manual' : isrc } },
    setWorkDetailsNotes: (state, notes) => { state.workDetails.notes = notes },
    
    setWorkDetailsWorkPoints: (state, points) => { state.workDetails.workPoints = points },
    setWorkDetailsForeignWorkIds: (state, ids) => { state.workDetails.foreignWorkIds = ids },
    setWorkDetailsDuration: (state, duration) => { state.workDetails.duration = duration },
    setWorkDetailsNotificationDate: (state, date) => { state.workDetails.notificationDate = date },
    setWorkDetailsStyle: (state, style) => { state.workDetails.style = style },
    setWorkDetailsBackCollection: (state, backCollection) => { state.workDetails.backCollection = backCollection },
    setWorkDetailsOldMrSplit: (state, split) => { state.workDetails.oldMrSplit = split },
    setWorkDetailsTags: (state, tags) => { state.workDetails.tags = tags },
    setWorkDetailsFavourites: (state, item) => { state.workDetails.favourites = item },
    setWorkDetailsFreeRoleSplitMusic: (state, item) => { state.workDetails.freeRoleSplitMusic = item },
    setWorkDetailsFreeRoleSplitText: (state, item) => { state.workDetails.freeRoleSplitText = item },
    setWorkDetailsLeadingPublisher: (state, publisher) => { state.workDetails.leadingPublisher = publisher },

    // DISTRIBUTION PANEL
    setWorkDistributions: (state, value) => { 
        if(Object.keys(value).length === 0) state.workDistributions = []
        else state.workDistributions.push(value) 
    },
    
    // WORK SHARES (not in use)
    setWorkShares: (state, shares) => { state.workShares = shares },

    // ALTERNATIVE TITLES Panel
    setWorksAlternativeTitles: (state, titles) => { state.worksAlternativeTitles = titles },
    setSelectedWorksAlternativeTitles: (state, selected) => { state.selectedWorksAlternativeTitles = selected },
    setDefaultWorksAlternativeTitles: (state) => { state.defaultWorksAlternativeTitles = DEFAULT_ALTERNATIVE_TITLES },
    // Editing Dialog
    setShowNoSharesDialog: (state, show) => { state.showNoSharesDialog = show},
    setShowDistributionSearchDialog: (state, show) => { state.showDistributionSearchDialog = show},
    setShowWorksAlternativeTitlesEditingDialog: (state, show) => { state.showWorksAlternativeTitlesEditingDialog = show },
    setWorksAlternativeTitlesEditingDialogDetails: (state, details) => { state.worksAlternativeTitlesEditingDialogDetails = details },
    setWorksAlternativeTitlesDetailsTitle: (state, title) => { state.worksAlternativeTitlesEditingDialogDetails.title = title },
    setWorksAlternativeTitlesDetailsType: (state, type) => { state.worksAlternativeTitlesEditingDialogDetails.type = type },
    setShowYearOfExpirationDialog: (state, value) => {state.showYearOfExpirationDialog = value},
    setShowFindDuplicatesDialog: (state, value) => {state.showFindDuplicatesDialog = value},
    setSelectedDuplicatesIdType: (state, value) => {state.selectedDuplicatesIdType = value},
    setSelectedDuplicatesScope: (state, value) => {state.selectedDuplicatesScope = value},
    setShowMergeWorksDialog: (state, value) => {state.showMergeWorksDialog = value},
    setMergeWorksTargetAlvId: (state, value) => {state.mergeWorksTargetAlvId = value},
    setMergeWorksSharesFromAlvId: (state, value) => {state.mergeWorksSharesFromAlvId = value},
    setMergeWorksPreview: (state, value) => {state.mergeWorksPreview = value},
    setMergeWorksResult: (state, value) => {state.mergeWorksResult = value},
    setMergeWorksErrorMsg: (state, value) => {state.mergeWorksErrorMsg = value},
    setMergeWorksIsLoading: (state, value) => {state.mergeWorksIsLoading = value},
    setMergeWorksIsConfirmed: (state, value) => {state.mergeWorksIsConfirmed = value},

    // OTHER PERSONS Panel
    setWorksOtherPersons:                                   (state, value) => { state.worksOtherPersons = value },
    setSelectedWorksOtherPersons:                           (state, value) => { state.selectedWorksOtherPersons = value },
    setDefaultWorksOtherPersons:                            (state) => { state.defaultWorksOtherPersons = DEFAULT_OTHER_PERSONS },

    // OTHER PERSONS Editing Dialog
    setShowWorksOtherPersonsEditingDialog:                  (state, show) => { state.showWorksOtherPersonsEditingDialog = show },
    setWorksOtherPersonsEditingDialogDetails:               (state, details) => { state.worksOtherPersonsEditingDialogDetails = details },
    setWorksOtherPersonsDetailsName:                        (state, name) => { state.worksOtherPersonsEditingDialogDetails.name = name },
    setWorksOtherPersonsDetailsType:                        (state, type) => { state.worksOtherPersonsEditingDialogDetails.type = type },
    
    // OTHER IDS Panel
    setWorksOtherIds:                                       (state, value) => { state.worksOtherIds = value },
    setWorksOtherIdsSearch:                                 (state, value) => { state.worksOtherIdsSearch = value },
    setSelectedWorksOtherIds:                               (state, value) => { state.selectedWorksOtherIds = value },
    setDefaultWorksOtherIds:                                (state) => { state.defaultWorksOtherIds = DEFAULT_OTHER_IDS },

    // OTHER IDS Editing Dialog
    setShowWorksOtherIdsEditingDialog:                      (state, value) => { state.showWorksOtherIdsEditingDialog = value },
    setWorksOtherIdsEditingDialogDetails:                   (state, value) => { state.worksOtherIdsEditingDialogDetails = value },
    setWorksOtherIdsDetailsSourceAlvId:                     (state, value) => { state.worksOtherIdsEditingDialogDetails.sourceAlvId = value },
    setWorksOtherIdsDetailsOtherId:                         (state, value) => { state.worksOtherIdsEditingDialogDetails.otherId = value },
    setWorksOtherIdsDetailsCountry:                         (state, value) => { state.worksOtherIdsEditingDialogDetails.country = value },

    // INSTRUMENTATION Panel
    setWorksInstrumentation:(state, value) => { state.worksInstrumentation = value },
    setSelectedWorksInstrumentation:(state, value) => { state.selectedWorkInstrumentation = value },
    setDefaultWorksInstrumentation:(state) => { state.defaultWorksInstrumentation = DEFAULT_INSTRUMENTAION },
    //Editing dialog
    setWorksInstrumentationEditingDialogDetails:(state, value) => { state.worksInstrumentationEditingDialogDetails = value },
    setShowWorksInstrumentationEditingDialog:(state, show) => { state.showWorksInstrumentationEditingDialog = show },
    setWorksInstrumentationDetailsTitle:(state, title) => { state.worksInstrumentationEditingDialogDetails.title = title },
    setWorksInstrumentationDetailsInstruments:(state, instruments) => { state.worksInstrumentationEditingDialogDetails.instruments = instruments },
    setWorksInstrumentationDetailsMusicians:(state, musicians) => { state.worksInstrumentationEditingDialogDetails.musicians = musicians },
    setWorksInstrumentationDetailsVoices:(state, voices) => { state.worksInstrumentationEditingDialogDetails.voices = voices },

    // ORIGINAL SHARES Panel
    setWorksOriginalShares: (state, shares) => { state.worksOriginalShares = shares },
    setSelectedWorksOriginalShares: (state, selected) => { state.selectedWorksOriginalShares = selected },
    // Editing Dialog
    setShowWorksOriginalSharesEditingDialog:        (state, value) => { state.showWorksOriginalSharesEditingDialog = value },
    setDefaultWorksOriginalShares:                  (state)        => { state.defaultWorksOriginalShares = DEFAULT_ORIGINAL_SHARES },
    setWorksOriginalSharesEditingDialogDetails:     (state, value) => { state.worksOriginalSharesEditingDialogDetails = value },
    setWorksOriginalSharesDetailsPrPercent:         (state, value) => { state.worksOriginalSharesEditingDialogDetails.prPercent = value },
    setWorksOriginalSharesDetailsMrPercent:         (state, value) => { state.worksOriginalSharesEditingDialogDetails.mrPercent = value},
    setWorksOriginalSharesDetailsRole:              (state, value) => { state.worksOriginalSharesEditingDialogDetails.role = value },
    setWorksOriginalSharesDetailsPwr:               (state, value) => { state.worksOriginalSharesEditingDialogDetails.pwr = value },
    setWorksOriginalSharesDetailsPmr:               (state, value) => { state.worksOriginalSharesEditingDialogDetails.pmr = value },
    setWorksOriginalSharesDetailsPrSociety:         (state, value) => { state.worksOriginalSharesEditingDialogDetails.prSociety = value },
    setWorksOriginalSharesDetailsMrSociety:         (state, value) => { state.worksOriginalSharesEditingDialogDetails.mrSociety = value },
    setWorksOriginalSharesDetailsInterestedParty:   (state, value) => { state.worksOriginalSharesEditingDialogDetails.azEntity = value },
    setWorksOriginalSharesDetailsShareType:         (state, value) => { state.worksOriginalSharesEditingDialogDetails.shareType = value },
    setWorksOriginalSharesInterestedPartyOptions:   (state, value) => { state.worksOriginalSharesInterestedPartyOptions = value },

    //Sheets and Projects
    setWorksSheetsAndProjects:                      (state, sheets) => { state.worksSheetsAndProjects = sheets },
    setWorksSheetsAndProjectsTotalListed:           (state, number) => { state.worksSheetsAndProjectsTotalListed = number },
    setWorksSheetsAndProjectsCurrentPage:           (state, number) => { state.worksSheetsAndProjectsCurrentPage = number },
    setWorksSheetsAndProjectsTotalRecords:          (state, number) => { state.worksSheetsAndProjectsTotalRecords = number },
    setWorksSheetsAndProjectsNumberOfPages:         (state, number) => { state.worksSheetsAndProjectsNumberOfPages = number },    

    setValidationMessagesWork:                      (state,value)   => { state.validationMessagesWork = value },
    clearValidationMessagesWork:                    (state)         => { state.validationMessagesWork = [] },

    setAzForOtherIdsSource:                         (state, value)  => { state.azForOtherIdsSource = value},
    setBulkEditConvertRoleToSharesReportCsv:         (state, path) => { state.bulkEditConvertRoleToSharesReportCsv = path },
    // Title Assist Dialog
    setWorksTitleAssistDialog:                   (state, value) => { state.showWorksTitleAssistDialog = value },
    setWorksTitleAssistSuggestions:              (state, value) => { state.worksTitleAssistSuggestions = value },
    setWorksTitleAssistDialogDetails:            (state, value) => { state.worksTitleAssistDialogDetails = value },
    setWorksTitleAssistDialogDetailsTitleAssistDraft: (state, value) => { state.worksTitleAssistDialogDetails.titleAssistDraft = value },
    setWorksTitleAssistDialogDetailsTitleAssistSelection: (state, value) => { state.worksTitleAssistDialogDetails.titleAssistSelection = value },
    setWorksTitleAssistDialogCheckbox:           (state, value) => { state.worksTitleAssistDialogCheckboxState = value },
    // Adapter for BaseEditPageTextField with context 'WorksTitleAssistDialog'
    setWorksTitleAssistDialogDetailsTitleAssistDraft: (state, value) => { state.worksTitleAssistDialogDetails.titleAssistDraft = value },
    setWorksTitleAssistLoading:                  (state, value) => { state.worksTitleAssistLoading = value },
}

const actions = {    
// AI: suggest international title from domestic title (logs/returns suggestions)
    async fetchAiIntlTitleSuggestions({ commit }, domesticTitle) {
        commit('setWorksTitleAssistDialog', true)
        commit('setWorksTitleAssistLoading', true)
        
        const res = await api.getIntlTitleSuggestions(domesticTitle)
        
        if (res && res.error === 1) {
            commit('setWorksTitleAssistLoading', false)
            commit('setWorksTitleAssistDialog', false)
            const errorMsg = res.response && res.response.errorMsg ? res.response.errorMsg : 'Validation error'
            return { error: true, errorMsg: errorMsg }
        }
        
        let suggestions = { literal: [], romaji: '', transcreation: [] }
        if (res && res.response) {
            const r = res.response
            if (r.literal || r.romaji || r.transcreation) {
                suggestions.literal = Array.isArray(r.literal) ? r.literal : []
                suggestions.romaji = r.romaji || ''
                suggestions.transcreation = Array.isArray(r.transcreation) ? r.transcreation : []
            } else if (Array.isArray(r.suggestions)) {
                suggestions.literal = r.suggestions
            }
        }
        // strip quotes and trim
        const normalize = s => (typeof s === 'string' ? s.replace(/^\"|\"$/g, '').replace(/^"|"$/g,'').trim() : s)
        suggestions.literal = suggestions.literal.map(normalize)
        suggestions.romaji = normalize(suggestions.romaji)
        suggestions.transcreation = suggestions.transcreation.map(normalize)
        commit('setWorksTitleAssistSuggestions', suggestions)
        commit('setWorksTitleAssistDialogDetailsTitleAssistDraft', '')
        commit('setWorksTitleAssistLoading', false)
        return suggestions
    },
// FETCH WORKS LIST
    async fetchWorks({ commit, getters, dispatch }) {
        commit('setIsLoading', true)
        
        // check for set filters
        let quality = ''
        let distribution = ''

        if(getters.getSelectedWorksQualityFilter === 'noShare'){
                quality = 'noShare'

                // let tempParamObj = { 'society': getters.getHomeSocietyCode}
                let tempParamObj = {}
     
                if(getters.getNoSharesHomeSocietyCheckbox.length !== 0){
                    tempParamObj['society'] = getters.getNoSharesHomeSocietyCheckbox
                }

                if(getters.getNoSharesCheckbox.length !== 0){
                    tempParamObj['original'] = getters.getNoSharesCheckbox.join(',')
                }
                // TODO for later 
                // Create society array when we extended noSharesDialog with society checkboxes
                // to add multiple societies to the api call params 
    
                let params = []
                for(let [key, value] of Object.entries(tempParamObj)) {
                    if(value !== '' && value !== null && value.length !== 0 && value !== undefined) { 
                        params.push(key + '=' + value)
                    }
                }
                params = params.join('%26')
                quality += '[' + params + ']'
           
        }else if(["lessThan100Share","100Share", "noUVZ", "withContractChains", "0Share", "noUvzOfContractingParty"].includes(getters.getSelectedWorksQualityFilter)){
            
            /*if(getters.getSelectedWorksQualityFilter === 'lessThan100Share'){
                quality = 'lessThan100Share'
            }else{
                quality = '100Share'
            }*/
            quality = getters.getSelectedWorksQualityFilter

            let tempParamObj = {}
            
            if(getters.getNoSharesHomeSocietyCheckbox.length !== 0){
                tempParamObj['society'] = getters.getNoSharesHomeSocietyCheckbox
            }

            if(getters.getNoSharesCheckbox.length !== 0){
                tempParamObj['original'] = getters.getNoSharesCheckbox.join(',')
            }
            
            let params = []
            for(let [key, value] of Object.entries(tempParamObj)) {
                if(value !== '' && value !== null && value.length !== 0 && value !== undefined) { 
                    params.push(key + '=' + value)
                }
            }
            params = params.join('%26')
            quality += '[' + params + ']'
        } 
        else if (getters.getSelectedWorksQualityFilter === 'distributionSearch') {
            let params = ''
            params += (getters.getDistributionSearchDetailsTarget.length != 0 ? 'target=' + String(getters.getDistributionSearchDetailsTarget).padStart(3, '0') : '')
            params += (getters.getDistributionSearchDetailsFunction.length != 0 ? ',function=' + getters.getDistributionSearchDetailsFunction : '')
            params += (getters.getDistributionSearchDetailsStatus.length != 0 ? ',status=' + getters.getDistributionSearchDetailsStatus : '')
            params += (getters.getDistributionSearchDetailsFrom ? ',from=' + getters.getDistributionSearchDetailsFrom : '')
            params += (getters.getDistributionSearchDetailsTo ? ',to=' + getters.getDistributionSearchDetailsTo : '')

            if (params.charAt(0) == ',') params = params.slice(1) // remove unwanted comma if target is not first parameter
            
            distribution += '[' + params + ']'
        } else if (getters.getSelectedWorksQualityFilter === 'yearOfExpiration') {
            quality = getters.getSelectedWorksQualityFilter

            let year = getters.getSelectedYearOfExpiration
            if(typeof year === "number" && year != 0){
                quality+= "[" + year + "]"
            }
        }
        else if (getters.getSelectedWorksQualityFilter === 'duplicates') {
            // One filter option, three backend filters: the dialog decides what is compared and
            // which works of a duplicate group are wanted
            let duplicatesFilters = {
                iswc: 'duplicateIswc',
                titleComposer: 'duplicateTitleComposer'
            }

            quality = duplicatesFilters[getters.getSelectedDuplicatesIdType] || 'workVersionDuplicates'
            quality += '[scope=' + getters.getSelectedDuplicatesScope + ']'
        }
        else {
            quality = getters.getSelectedWorksQualityFilter
        }
        let filterObj = {
            'search' :  getters.getWorksSearch,
            'quality' : quality,
            'status' : getters.getSelectedWorksStatusFilter,
            'distribution' : distribution,
        }

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        // Get list items from db
        // let response = await api.getListData(DIR, getters.getCurrentPage, paramsString) 
        let options = getters.getWorksServerSideSortingOptions  
        let sortBy = options.sortBy
        let sortDesc = options.sortDesc

        // Duplicates only make sense side by side, so the search sorts by the column carrying the
        // duplicate value. It deliberately stays out of the sorting options: the list watches those
        // and would run the search by itself, which no other filter of the app does. A sorting the
        // user picked in a column header stays untouched, and title duplicates need nothing here
        // because the title is what the list sorts by anyway
        let duplicatesSortColumns = { workId: 'gemaNumber', iswc: 'iswc' }
        let duplicatesSortColumn = duplicatesSortColumns[getters.getSelectedDuplicatesIdType]

        if(getters.getSelectedWorksQualityFilter === 'duplicates' && String(sortBy) === 'title' && duplicatesSortColumn !== undefined) {
            sortBy = [duplicatesSortColumn]
            sortDesc = [false]
        }

        let response = await api.getListData2(DIR, getters.getCurrentPage, sortBy, sortDesc, paramsString)
        
        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setWorks', [])
        } else {
            commit('setWorks', response.list)   
        }
        dispatch('setDefaultPublishingCompany')
        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)
        commit('setIsLoading', false)
    },

// FETCH DETAILS
    async fetchWorksDetails({ commit, getters, dispatch }, alvId) {
        let values

        if(alvId === 'new') {
            let defaultValues = JSON.parse(JSON.stringify(getters.getDefaultNewWork)) 
            values = defaultValues
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            values['status'] = getters.getCreateNewWorkStatus
        }
        else {
            let response = await api.getDetailsById(DIR, alvId)
            if(response === undefined || response.length === 0 || response.error === 1) {
                response = {}
                commit('setSnackbar', {
                    type: 'error',
                    msg: 'Daten konnten nicht oder nur unvollständig geladen werden'
                })
            } else {
                values = response
                response.type === "spw" ? commit("setWorkShareType",{text: "OWN%", value: "own"})  : commit("setWorkShareType",{text: "ROLE%", value: "role"}) 
            }
        }
        
        // transform duration (seconds) into hh:mm:ss or mm:ss format
        values.duration =  this._vm.$alvPlugin.transformSecondsToDuration(values.duration)
    
        // freeRoleSplitMusic comes from BE backend
        let freeRoleSplitMusic = values['freeRoleSplitMusic']

        if (freeRoleSplitMusic != null) {
            values['freeRoleSplitText'] = (100-freeRoleSplitMusic).toFixed(2)
        } else {
            values['freeRoleSplitText'] = null
        }

        let freeRoleSplitText = values['freeRoleSplitText']
        if (i18n.locale == 'de') {
            values.freeRoleSplitMusic = freeRoleSplitMusic ? freeRoleSplitMusic.toString().replace('.', ',') : freeRoleSplitMusic
            values.freeRoleSplitText = freeRoleSplitText ? freeRoleSplitText.toString().replace('.', ',') : freeRoleSplitText
        }

        commit('setWorksDetails', values)
        // Load Dropdown Options
        dispatch('fetchWorkDropdowns')
        // Load Panel Data
        dispatch('fetchWorksOtherPersons')
        dispatch('fetchWorksOtherIds')
        dispatch('fetchWorksAlternativeTitles')
        dispatch('fetchWorksInstrumentation')
        if(alvId !== 'new') dispatch('fetchWorksOriginalShares') 
        else commit('setWorksOriginalShares', {}) 
    },
    
    // ALTERNATIVE TITLES Panel
    async fetchWorksAlternativeTitles({ commit, getters }) {
        let titlesFromDb = getters.getWorksDetails.alternativeTitles
        
        if(titlesFromDb === undefined || titlesFromDb === null) commit('setWorksAlternativeTitles', [])
        else {
            if(titlesFromDb.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND') 
            commit('setWorksAlternativeTitles', titlesFromDb)
        }
    },
    // DELETE
    async deleteSelectedWorksAlternativeTitles({ getters, commit }) {
        let selectedTitle = getters.getSelectedWorksAlternativeTitles // only one id is passed
        let index = getters.getWorksAlternativeTitles.findIndex(title => title.id === selectedTitle)

        let startTitleAmount = getters.getWorksAlternativeTitles.length
        // delete title in the FE
        Vue.delete(getters.getWorksAlternativeTitles, index) 
        let newTitleAmount = getters.getWorksAlternativeTitles.length

        if(startTitleAmount > newTitleAmount) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_PUBLISHING_WORKS_SNACKBAR_DELETE_OTHER_TITLE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_PUBLISHING_WORKS_SNACKBAR_DELETE_OTHER_TITLE_NOT_SUCCESSFUL'),
            })
        }

        commit('setSelectedWorksAlternativeTitles', [])
        if(newTitleAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    },

    // OTHER PERSONS Panel
    async fetchWorksOtherPersons({ commit, getters }) {
        let personsFromDb = getters.getWorksDetails.otherInterestedParties
        
        if(personsFromDb === undefined || personsFromDb === null) commit('setWorksOtherPersons', [])
        else {
            if(personsFromDb.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND') 
            commit('setWorksOtherPersons', personsFromDb)
        }
    },

    // OTHER IDS Panel
    async fetchWorksOtherIds({ commit, getters }) {
        let idsFromDb = getters.getWorksDetails.otherIds
        
        if(idsFromDb === undefined || idsFromDb === null) commit('setWorksOtherIds', [])
        else {
            if(idsFromDb.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND') 
            commit('setWorksOtherIds', idsFromDb)
        }
    },

    // Fetch Sources from A-Z
    async fetchAzForOtherIdsSource({ commit }) {
        let i = await api.getAzForMapping("import")
        const filteredList = i.list.filter(source => source.value !== 'erp-invoicing')
        commit('setAzForOtherIdsSource', filteredList)
    },

    // DELETE
    async deleteSelectedWorksOtherPersons({ getters, commit }) {
        let selectedPerson = getters.getSelectedWorksOtherPersons // only one id is passed
        let index = getters.getWorksOtherPersons.findIndex(person => {
            return JSON.stringify(person) === JSON.stringify(selectedPerson)
        })
        
        let startPersonsAmount = getters.getWorksOtherPersons.length
        Vue.delete(getters.getWorksOtherPersons, index)
        let newPersonsAmount = getters.getWorksOtherPersons.length

        if(startPersonsAmount > newPersonsAmount) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'),
            })
        }

        commit('setSelectedWorksOtherPersons', [])
        if(newPersonsAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    },

    async deleteSelectedWorksOtherIds({ getters, commit }) {
        let selectedId = getters.getSelectedWorksOtherIds // only one id is passed
        let index = getters.getWorksOtherIds.findIndex(id => {
            return JSON.stringify(id) === JSON.stringify(selectedId)
        })
        
        let startIdsAmount = getters.getWorksOtherIds.length
        Vue.delete(getters.getWorksOtherIds, index)
        let newIdsAmount = getters.getWorksOtherIds.length

        if(startIdsAmount > newIdsAmount) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'),
            })
        }

        commit('setSelectedWorksOtherIds', [])
        if(newIdsAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    },

    // INSTRUMENTATION Panel
    async fetchWorksInstrumentation({ getters, commit }) {
        let instrumentationsFromDB = getters.getWorksDetails.instrumentation
        
        if(instrumentationsFromDB === undefined || instrumentationsFromDB === null) commit('setWorksInstrumentation', [])
        else {
            if(instrumentationsFromDB.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND') 
            commit('setWorksInstrumentation', instrumentationsFromDB)
        }
    },
    
    // DELETE Shares
    async deleteSelectedWorksInstrumentation({getters, commit, dispatch }) {
        let selectedInstumentation = getters.getSelectedWorksInstrumentation // only one id is passed
        let index = getters.getWorksInstrumentation.findIndex(instrument => instrument.id === selectedInstumentation.id)

        let startTitleAmount = getters.getWorksInstrumentation.length
        // delete title in the FE
        Vue.delete(getters.getWorksInstrumentation, index) 
        let newTitleAmount = getters.getWorksInstrumentation.length

        if(startTitleAmount > newTitleAmount) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'),
            })
        }

        commit('setSelectedWorksInstrumentation', [])
        if(newTitleAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    
    },
    // ORIGINAL SHARES Panel
    async fetchWorksOriginalShares({ getters, commit }) {
        commit('setIsLoading', true)
        let workAlvId = getters.getWorkDetailsAlvId
        let response = await api.getListData(DIR + '/' + workAlvId + '/originalShares')

        if(response === undefined || response.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setWorksOriginalShares', {})   
        } else {
            let sortedOriginalShares = this._vm.$alvPlugin.sortingOriginalInterestedPartiesByRole(response)
            commit('setWorksOriginalShares', sortedOriginalShares)   
        }

        commit('setIsLoading', false)
    },
    // ADD/EDIT Shares
    async addWorksOriginalShares({ getters, commit, dispatch }) {
        let workAlvId = getters.getWorkDetailsAlvId
        let shareDetails = getters.getWorksOriginalSharesEditingDialogDetails

        // formatting empty string to null
        shareDetails['prPercent'] = shareDetails['prPercent'] === '' ? null : shareDetails['prPercent']
        shareDetails['mrPercent'] = shareDetails['mrPercent'] === '' ? null : shareDetails['mrPercent']

        let response = await api.addRowToDataTable(DIR + '/' + workAlvId, shareDetails, "addInterestedParty")

        if(response.error === -1) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_SUCCESSFUL'),
            })
            dispatch('fetchWorksOriginalShares')
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_NOT_SUCCESSFUL'),
            })
        }
    },
    // DELETE Shares
    async deleteSelectedWorksOriginalShares({getters, commit, dispatch }) {
        let workAlvId = getters.getWorkDetailsAlvId
        let selectedShare = getters.getSelectedWorksOriginalShares

        let response = await api.deleteEntries(DIR + '/' + workAlvId + '?deleteOriginalShare', [selectedShare])

        if(response.error === -1) {
            dispatch('fetchWorksOriginalShares')
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_DELETED')
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_NOT_DELETED'),
            })
        }

        commit('setSelectedWorksOriginalShares', [])
        if(getters.getWorksOriginalShares.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    },
    // Autocomplete Interested Party
    async fetchAutocompleteWorksOriginalSharesInterestedParty({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setWorksOriginalSharesInterestedPartyOptions', response.list)
    },

    async fetchAutocompleteWorksCwrPublisherSourceAz({ getters, commit }, input) {
        let response = {}
        
        if (getters.getWorksDetailsImportCwrType === 'nonAckPublisher' || getters.getSelectedFileImport === 'cwrJson' || getters.getWorksDetailsImportCwrType === 'cwrJson') {
            response = await api.getAutocompleteSearch('az/groups', input)
        } else {
            response = await api.getAutocompleteSearch('az/societies', input)
        }

        commit('setWorksCwrPublisherSourceAzOptions', response.list)
    },

    //Projects and Sheets Panel

    async fetchWorksProjectsSheets({ commit, getters }){

        commit('setIsLoading', true)
        let workAlvId = getters.getWorkDetailsAlvId
        let response = await api.getListData(DIR + '/' + workAlvId + '/sheets', getters.getWorksSheetsAndProjectsCurrentPage)
        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setWorksSheetsAndProjects', [])   
        } else {
            commit('setWorksSheetsAndProjects', response.list)
            commit("setWorksSheetsAndProjectsTotalListed", response.filteredRecords)
            commit("setWorksSheetsAndProjectsCurrentPage",response.currentPage)
            commit("setWorksSheetsAndProjectsTotalRecords",response.totalRecords)
            commit("setWorksSheetsAndProjectsNumberOfPages",  response.numberOfPages)
        }

        commit('setIsLoading', false)
    },

    // DROPDOWNS
    async fetchWorkDropdowns({ commit, getters }) {
        let alvId = getters.getWorkDetailsAlvId
        
        commit('setSocieties')
        let leadingPublishersResponse = await api.getSpecificDropdownValues(DIR, alvId, 'leadingPublishers')
        commit('setLeadingPublishers', leadingPublishersResponse.response.leadingPublishers)
    },

    async fetchWorkSubpublishers({ commit, getters }) {
        let alvId = null
        // When doing bulk edit of all works in search list use first workId to get subpublishers
        // When doing bulk edit of selected works (through action) use first workId to get subpublishers
        if (getters.getBulkEditingAllWorks) {
            let works = getters.getWorks === undefined ? [] : getters.getWorks
            
            // If there are no works in the search results just leave empty SE list
            if (works.length === 0) {
                commit('setWorksBulkEditingDetailsRemoveSEArray', [])
                return
            }
            alvId = works[0].alvId
        } else {
            alvId = getters.getSelectedWorks[0]
        }

        let response = await api.getListData(DIR + '/' + alvId + '/originalShares')
        if(response != undefined || response.list.length != 0) {
            let arrayOfSE = []
            for (let [shareType, shares] of Object.entries(response)) {
                shares.forEach((party, i) => {
                    if (party.role == "SE") {
                        arrayOfSE.push({text: party.name, value: party.azEntity.id, shareType: shareType})
                    }
                })
            }
            commit('setWorksBulkEditingDetailsRemoveSEArray', arrayOfSE)
        }
    },

    // Used for Pseudo-SLG contract selection, i.e. for STIM (Amboss Film) or UFC (guesstimate)
    async fetchSlgContracts({ commit, getters }) {
        let slgContracts = await api.getContractsByType('publishing', 'SLG')
        commit('setExportWorksSlgContracts', slgContracts)
    },

    async fetchExportPublisherEntries({ commit, getters }) {
        let entries = [];
        let work;

        // If no works are checked, use the first work in the result set
        if (state.selectedWorks.length === 0) {
            let firstWork = getters.getWorks[0];
            work = firstWork ? firstWork.alvId : null; // Safely fetch the first work's alvId
        } else {
            work = state.selectedWorks[0]; // Use the first selected work
        }
        if (!work) {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_PUBLISHING_WORKS_NO_WORKS_FOUND'),
            });
            return;
        }
    
        let response = await api.getListData(`publishing/works/${work}/originalShares`)

        if (response) {
            let shareType = getters.getExportWorksDetailsShareType; // either 'own' or 'intl'
            
            if (shareType === "intl" && response.intl) {
                entries = response.intl
                    .filter(entry => entry.role === 'E')
                    .map(entry => ({
                        text: entry.name,
                        value: entry.azEntity.id
                    }));
            } else if (shareType === "own" && response.own) {
                entries = response.own
                    .filter(entry => entry.role === 'E')
                    .map(entry => ({
                        text: entry.name,
                        value: entry.azEntity.id
                    }));
            } else {
                entries = []; // Fallback to empty array if no valid data
            }
        } else {
            entries = []; // Fallback for empty response
        }
        
    
        commit('setExportPublisherEntries', entries) // for Dynamic Society Affiliation, i.e. STIM or SACEM
        commit('setExportWorksDetailsSelectedPublisherEntry', null) // for export
        commit('setWorksRegistrationDetailsSelectedPublisherEntry', null) // for work registration
    },    

    // SAVE EDIT FORM
    async saveWorksForm({ commit, getters, dispatch }, redirect = true) {
        let alvId = getters.getWorkDetailsAlvId

        getters.getWorksDetails.instrumentation             = getters.getWorksInstrumentation
        getters.getWorksDetails.alternativeTitles           = getters.getWorksAlternativeTitles
        getters.getWorksDetails.otherInterestedParties      = getters.getWorksOtherPersons
        getters.getWorksDetails.otherIds                    = getters.getWorksOtherIds
        getters.getWorksDetails.otherIds = (getters.getWorksOtherIds && getters.getWorksOtherIds.length > 0) ? getters.getWorksOtherIds : []
        getters.getWorksDetails.originalInterestedParties   = getters.getWorksOriginalShares
        // let uniqueId = getters.getWorkUniqueId
        let metaData = _.cloneDeep(getters.getWorksDetails)

        if (i18n.locale == 'de') {
            if (metaData.freeRoleSplitMusic) {
                metaData.freeRoleSplitMusic = metaData.freeRoleSplitMusic.replace(',', '.')
            }
            if (metaData.freeRoleSplitText) {
                metaData.freeRoleSplitText = metaData.freeRoleSplitText.replace(',', '.')
            }
        }

        let isNew = false

        if(!redirect) { isNew = getters.getWorksDetails['id'] === 0 }
        else isNew = router.currentRoute.params.alvId === "new"

        // validate PWR ROLE% sum of Writer-representing publishers to be 100%
        await dispatch('validateUVZShares', getters.getWorksDetails['type'])

        delete metaData.originalInterestedParties
        let response = await api.saveEditForm(DIR, alvId, metaData, isNew)

        if(response === undefined || response.length === 0 || response.error === 1) { 
            let errorMsg = i18n.t(response.response.errorMsg)
            if (response.response.dialogParameters) {
                errorMsg = this._vm.$alvPlugin.buildParameterizedMessage(response.response.errorMsg, response.response.dialogParameters)
            }
            let isWarning = response.response.errorMsg === 'lang_PUBLISHING_WORKS_MESSAGE_ERROR_WORK_ID_ALREADY_IN_USE'
            commit('setSnackbar', { 
                type: isWarning ? 'warning' : 'error', 
                msg: errorMsg, 
            })
        } else {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_PUBLISHING_WORKS_SNACKBAR_WORK_SAVED')
            })
            // redirect for url now with ALVID
            if(isNew && redirect) {
                router.push( { name: 'WorksEdit', params: { alvId:  response.response.alvId } })
            }
            // refresh data
            await dispatch('fetchWorksDetails',  response.response.alvId)
        }
    },      

    // Validation of ROLE%, especially the sum of UVZ-representing Publishers shares = 100%?
    // HOME_SOCIETY is GEMA, Publisher share is GEMA member in AR/MR, and Type=OVW original work, in warning show (Role)
    // Added tolerance in validation (checking 100%) due to ALVSERVICE-1700
    async validateUVZShares({ getters, commit }, workType) {
        commit('clearValidationMessagesWork')
        const roleShares = getters.getWorksDetails.originalInterestedParties.role
    
        // Ensure roleShares is an array or skip validation if it doesn't exist
        if (!Array.isArray(roleShares) || roleShares.length === 0) {
            commit('clearValidationMessagesWork') // Clear previous messages if no validation is needed
            return 0 // No delay needed
        }
    
        // Skip validation if no GEMA member among publishers with roles E or SE, or validation conditions aren't met
        if (
            !roleShares.some(
                publisher =>
                    (publisher.role === 'E' || publisher.role === 'SE') &&
                    (publisher.mrSociety === 35 || publisher.prSociety === 35)
            ) ||
            getters.getHomeSociety !== "GEMA" ||
            workType !== "opw"
        ) {
            commit('clearValidationMessagesWork') // Clear previous messages
            return 0 // No delay needed
        }
        
        let messages = []
        const roleTotals = {
            C: { mrPercent: 0, prPercent: 0 },
            A: { mrPercent: 0, prPercent: 0 },
            AR: { mrPercent: 0, prPercent: 0 }
        }
        const publisherTracker = new Map()
        let hasComposer = false
    
        for (const party of roleShares) {
            // Sum totals for each writer's role
            if (['A', 'C', 'AR'].includes(party.role)) {
                if (party.role === 'C') hasComposer = true
    
                roleTotals[party.role].mrPercent += parseFloat(party.mrPercent) || 0
                roleTotals[party.role].prPercent += parseFloat(party.prPercent) || 0
    
                // Validate representing publishers' shares
                let writerMrTotal = 0
                let writerPrTotal = 0

                // Fix for Unpublished Authors (pwr is empty) => do not validate his representing Publisher ROLE%
                if (!party.pwr || party.pwr.length === 0) {
                    continue;
                }
    
                for (const pwr of party.pwr || []) {
                    const publisher = roleShares.find(
                        pub => pub.id === pwr.id && pub.position === pwr.position
                    )
    
                    if (publisher) {
                        // Sum MR and PR shares of representing publishers
                        writerMrTotal += parseFloat(publisher.mrPercent) || 0
                        writerPrTotal += parseFloat(publisher.prPercent) || 0
    
                        // Check for duplicate publishers
                        const publisherKey = `${pwr.id}-${pwr.position}`
                        if (publisherTracker.has(publisherKey)) {
                            const conflictWriter = publisherTracker.get(publisherKey)
                            messages.push({
                                type: 'warning',
                                msg: i18n.t('lang_PUBLISHING_WORKS_VALIDATION_DUPLICATE_PUBLISHER')
                            })
                        } else {
                            publisherTracker.set(publisherKey, party.name)
                        }
                    }
                }
    
                // Check if representing publishers' shares for the writer total 100%
                if (Math.abs(writerPrTotal - 100) > 0.01) {
                    messages.push({
                        type: 'warning', 
                        msg: `${i18n.t('lang_PUBLISHING_WORKS_VALIDATION_PUBLISHER_PR_NOT_100')} (${party.role}=${writerPrTotal}%)` 
                    })
                }
                if (Math.abs(writerMrTotal - 100) > 0.01) {
                    messages.push({
                        type: 'warning',
                        msg: `${i18n.t('lang_PUBLISHING_WORKS_VALIDATION_PUBLISHER_MR_NOT_100')} (${party.role}=${writerMrTotal}%)` 
                    })
                }
            }
        }
    
        // Check role totals for C, A, and AR
        for (const [role, totals] of Object.entries(roleTotals)) {
            if (totals.mrPercent === 0 && totals.prPercent === 0 && role !== 'C') continue
    
            if (role === 'C' && !hasComposer) {
                messages.push({
                    type: 'warning',
                    msg: i18n.t('lang_PUBLISHING_WORKS_VALIDATION_COMPOSER_MISSING')
                })
            }
    
            if (Math.abs(totals.prPercent - 100) > 0.01) {
                messages.push({
                    type: 'warning',
                    msg: `${i18n.t('lang_PUBLISHING_WORKS_VALIDATION_ROLE_PR_NOT_100')} (${role}=${totals.prPercent}%)` 
                })
            }
            if (Math.abs(totals.mrPercent - 100) > 0.01) {
                messages.push({
                    type: 'warning',
                    msg: `${i18n.t('lang_PUBLISHING_WORKS_VALIDATION_ROLE_MR_NOT_100')} (${role}=${totals.mrPercent}%)`  
                })
            }
        }
    
        // Commit validation messages to the store
        commit('setValidationMessagesWork', messages)
    
        return
    },                      
    

// ACTIONS Switch
    /** Checks if at least 1 work is selected and commit what the action triggers.
     * 	If no work is selected a Dialog is shown. 
     *  If at least 1 work is selected it shows e.g. an specific dialog.
     * @param {Object} commit muations object from store.
     */
    async doWorksAction({ commit, getters, dispatch }) {
            switch(state.selectedWorksAction) {
                case 'delete':
                    if(state.selectedWorks.length > 0){
                        commit('setShowDeletionDialog', true)
                    }else{
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                        commit('setShowSelectionRequiredDialog', true) 
                    }
                    break
                case 'mergeWorks':
                    // A merge needs a target work and at least one work to fold into it
                    if(state.selectedWorks.length > 1){
                        dispatch('openMergeWorksDialog')
                    }else{
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_MORE_THAN_ONE')
                        commit('setShowSelectionRequiredDialog', true)
                    }
                    break
                case 'addContract':
                    if(state.selectedWorks.length > 0){
                        commit('setShowSearchDialog', true)
                    }else{
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                        commit('setShowSelectionRequiredDialog', true) 
                    }
                    break
                case 'gemaSoundfile':
                    if(state.selectedWorks.length > 0){
                        let r = await dispatch('checkGemaSoundfileCredentials')
                        if(r.error == -1) {
                            commit('setShowGemaSoundfileDialog', true)
                        } else {
                            commit('setSnackbar', {
                                type: 'error',
                                msg: i18n.t(r.response.errorMsg)
                            })
                        }
                    }else{
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                        commit('setShowSelectionRequiredDialog', true)  
                    }
                    break
                case 'replaceTags':
                    if(state.selectedWorks.length == 0){
                        let r = await dispatch('runConfirmationDialog');
                        if (r) {
                            commit('setExpandedWorks', [])
                            commit('setShowManageTagsDialog', true)    
                        }
                    }else {
                        commit('setExpandedWorks', [])
                        commit('setShowManageTagsDialog', true)
                    }
                    break

                case 'worksRegistration':
                    if (state.selectedWorks.length === 0) {
                        // No works selected: Confirm for all works in the current search result
                        let r = await dispatch('runConfirmationDialog'); // Ask user for confirmation
                        if (r) {
                            commit('setExportAllWorks', true); // register all works in result set, no work is checked!
                            dispatch('fetchExportPublisherEntries'); // Prepare necessary data
                            commit('setWorksRegistrationDialogStepText', i18n.t('lang_PUBLISHING_WORKS_WORK_REGISTRATION_STEP_1_OF_3'));
                            commit('setShowWorksRegistrationDialog', true); // Show the dialog
                        }
                    } else {
                        // Works selected: Proceed with registration for selected works
                        commit('setExportAllWorks', false); // Indicate registration for selected works
                        dispatch('fetchExportPublisherEntries'); // Prepare necessary data
                        commit('setWorksRegistrationDialogStepText', i18n.t('lang_PUBLISHING_WORKS_WORK_REGISTRATION_STEP_1_OF_3'));
                        commit('setShowWorksRegistrationDialog', true); // Show the dialog
                    }
                    break;

                case 'worksBulkEditing':
                    if(state.selectedWorks.length == 0) {
                        //BulkEditingAllWorks
                        let r = await dispatch('runConfirmationDialog')
                        if(r){
                            commit('setBulkEditingAllWorks', true) 
                            commit('setShowWorksBulkEditingDialog', true)
                            dispatch('fetchWorkSubpublishers')
                        }
                        break
                    }
                    dispatch('fetchWorkSubpublishers') // to prepare (once) for removeSE action
                    commit('setShowWorksBulkEditingDialog', true)
                    commit('setBulkEditingAllWorks', false)
                    break
                case 'testCalculationGema':
                    if(state.selectedWorks.length === 1) {
                        dispatch('fetchTestCalculationGema')
                    } else {
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                        commit('setShowSelectionRequiredDialog', true)
                    }
                    break
                case 'testCalculationSvd':
                    if(state.selectedWorks.length === 1) {
                        dispatch('fetchTestCalculationSvd')
                    } else {
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                        commit('setShowSelectionRequiredDialog', true)
                    }
                    break
                case 'testCalculationC3':
                    if(state.selectedWorks.length === 1) {
                        commit('setTestCalculationC3Dialog', true)
                    } else {
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                        commit('setShowSelectionRequiredDialog', true)
                    }
                    break
                case 'exportWorks':
                    if(state.selectedWorks.length == 0){
                        //Export All
                        let r = await dispatch('runConfirmationDialog')
                        if(r){
                            commit('setExportAllWorks', true)
                            commit('setShowExportWorksDialog', true)
                        }
                    }else{
                        dispatch('fetchExportPublisherEntries')
                        commit('setExportAllWorks', false)
                        commit('setShowExportWorksDialog', true)
                    }
                    break
                case 'dataSharing':
                    let r = await dispatch('runConfirmationDialog')
                    if (r) {
                        commit('setShowDataSharingDialog', true)
                    }
                    break
                case 'copy':
                    if(state.selectedWorks.length === 1) {
                        dispatch('copyWork')
                    } else {
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                        commit('setShowSelectionRequiredDialog', true)
                    }
                    break
            }      
    },

// Action: ADD CONTRACTS  to works
    async addContractsToWorks({ getters, dispatch, commit }) {
        let response = await api.addContractsToWorks(DIR, getters.getSelectedWorks, getters.getSelectedContractsForWorks)  
        
        if(response.error === -1) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERAL_SNACKBAR_ADDED_SUCCESSFULLY')
            })
        }

        commit('setSelectedWorksAction', []) 
        commit('setExpandedWorks', [])
    },
    // Helper
    async searchContractsForWorks({ getters }) {
        let response = await api.getContractsByWorkIds(getters.getContractsForWorksSearch, getters.getSelectedWorks)
        return response
    },    

// Action: DELETE
    async deleteSelectedWorks({ commit, getters, dispatch }) {  
        const response = await api.deleteEntries(DIR, getters.getSelectedWorks)

        if(response.error === -1) {        
            for(let i = 0; i < getters.getSelectedWorks.length; i++) {
                let index = getters.getWorks.findIndex(work => work.alvId == getters.getSelectedWorks[i])
                Vue.delete(getters.getWorks, index)
            }

            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_DELETED')
            })

            commit('setSelectedWorks', [])
            commit('setIsAllSelectedWorks', false)
            commit('setSelectedWorksAction', [])
            dispatch('fetchWorks')
        }
    },

// Action: MERGE WORKS
    async openMergeWorksDialog({ commit, dispatch }) {
        commit('setMergeWorksTargetAlvId', null)
        commit('setMergeWorksSharesFromAlvId', null)
        commit('setMergeWorksPreview', null)
        commit('setMergeWorksResult', null)
        commit('setMergeWorksErrorMsg', null)
        commit('setMergeWorksIsConfirmed', false)
        commit('setShowMergeWorksDialog', true)

        // The list rows carry no status, so the works are described by the backend before a target
        // work can be offered
        await dispatch('fetchMergeWorksPreview')
    },

    async fetchMergeWorksPreview({ commit, getters }) {
        commit('setMergeWorksIsLoading', true)
        commit('setMergeWorksErrorMsg', null)
        commit('setMergeWorksIsConfirmed', false)

        let metaData = {
            alvIds: getters.getSelectedWorks,
            targetAlvId: getters.getMergeWorksTargetAlvId,
            sharesFromAlvId: getters.getMergeWorksSharesFromAlvId
        }
        let response = await api.triggerAction(DIR, metaData, { action: 'mergePreview' })

        if(response.error === -1) {
            commit('setMergeWorksPreview', response.response)
        } else {
            commit('setMergeWorksErrorMsg', response.response.errorMsg)
        }

        commit('setMergeWorksIsLoading', false)
    },

    async mergeWorks({ commit, getters, dispatch }) {
        commit('setMergeWorksIsLoading', true)
        commit('setMergeWorksErrorMsg', null)

        let metaData = {
            alvIds: getters.getSelectedWorks,
            targetAlvId: getters.getMergeWorksTargetAlvId,
            sharesFromAlvId: getters.getMergeWorksSharesFromAlvId
        }
        let response = await api.triggerAction(DIR, metaData, { action: 'merge' })

        if(response.error === -1) {
            commit('setMergeWorksResult', response.response)
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_PUBLISHING_WORKS_MERGE_MESSAGE_SUCCESS')
            })
            commit('setSelectedWorks', [])
            commit('setIsAllSelectedWorks', false)
            commit('setSelectedWorksAction', [])
            commit('setExpandedWorks', [])
            commit('setShowMergeWorksDialog', false)
            dispatch('fetchWorks')
        } else {
            commit('setMergeWorksErrorMsg', response.response.errorMsg)
        }

        commit('setMergeWorksIsLoading', false)
    },

// Action: GEMA SOUNDFILE 
    async checkGemaSoundfileCredentials() {
        let response = await api.getCredentialsStatus('account/credentials', "gema-soundfile")
      
        return response
    },
    async sendWorksGemaSoundfile({ commit, dispatch, getters }) {
        let metaData = {
            "workIds" : state.selectedWorks,
            "approvals" : getters.getGemaSoundfileDialogApprovalsCheckbox
        }

        let queryParams = {
            "action": "gemaSoundfile"
        }

        let r = await api.triggerAction(DIR, metaData, queryParams)

        return r
    },

// Action: GEMA REPERTOIRE (token based search, without shares)
    async fetchGemaRepertoireVersions({ commit }, { workNumber }) {
        const response = await api.getGemaRepertoireVersions(workNumber)

        if (!response || response.error === 1) {
            const msg =
                (response && response.errorMsg) ? response.errorMsg :
                (response && response.response && response.response.errorMsg) ? response.response.errorMsg :
                'lang_ERROR_UNKNOWN'
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t(msg)
            })
            return
        }

        // cache result for potential UI (dialog/table) usage
        commit('setGemaRepertoireVersions', response.response || response)
    },

// Action: Check if GEMA work versions exist in ALV
    async checkGemaVersionsExistence({ commit }, { workVersions }) {
        const response = await api.checkGemaVersionsExistence(workVersions)

        if (!response || response.error === 1) {
            const msg =
                (response && response.errorMsg) ? response.errorMsg :
                (response && response.response && response.response.errorMsg) ? response.response.errorMsg :
                'lang_ERROR_UNKNOWN'
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t(msg)
            })
            return null
        }

        return response.response || response
    },

// Action: TESTCALCULATON GEMA
    // Fetch data for fields in Dialog
    async fetchTestCalculationGema({ commit, getters }) {
        let response = await api.getSpecificFormData(DIR + '/testCalculation', 'type=gema')

        if(response.error === -1) {
            // format numbers for display
            response.response.percent = i18n.n(response.response.percent, 'number') 
            response.response.amount = i18n.n(response.response.amount, 'number')
            
            // set form values and dropdowns
            commit('setTestCalculationGemaForm', response.response)
            commit('setTestCalculationGemaDialog', true)
            commit('setTestCalculationGemaFormTypeOfRightsValues', response.response.contractRightsValues)
            commit('setTestCalculationGemaFormBgValues', response.response.bgValues)
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: 'Es ist ein Fehler aufgetreten' // TODO: lang const from BE or FE?!
            })
        }
        
    },
    // Autocomplete field Ykto
    async fetchAutocompleteTestCalculationGemaYkto({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input, "ktoExists=true")
        commit('setTestCalculationGemaYktoOptions', response.list)
    },
    // Calculate
    async calculateGemaTestCalculation({ getters, commit }) {
        let queryParams = {
            "action": "testCalculation",
            "type": "gema"
        }

        let metaData = _.cloneDeep(getters.getTestCalculationGemaForm)
        metaData.amount = this._vm.$alvPlugin.normalizeDecimalFormat(metaData.amount)
        metaData["workIds"] = getters.getSelectedWorks
        delete metaData.bgValues
        delete metaData.contractRightsValues

        let response = await api.triggerAction(DIR, metaData, queryParams)
        if(response.error === -1) {
            commit('setTestCalculationGemaResult', response.response)
        } else {
            commit('setTestCalculationGemaResultErrorMessage', response.errorMsg)
        }
    },

// Action: TESTCALCULATON SVD
    // Fetch data for fields in Dialog
    async fetchTestCalculationSvd({ commit }) {
        let response = await api.getSpecificFormData(DIR + '/testCalculation', 'type=svd')
        
        if(response.error === -1) {
            // format numbers for display
            response.response.percent = i18n.n(response.response.percent, 'number') 
            response.response.amount = i18n.n(response.response.amount, 'number')

            commit('setTestCalculationSvdForm', response.response)
            commit('setTestCalculationSvdDialog', true)
            commit('setTestCalculationSvdFormTypeOfRightsValues', response.response.contractRightsValues)
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: 'Es ist ein Fehler aufgetreten' // TODO: lang const from BE or FE?!
            })
        }
    }, 
    // Calculate
    async calculateSvdTestCalculation({ getters, commit }) {
        let queryParams = {
            "action": "testCalculation",
            "type": "svd"
        }

        let metaData = getters.getTestCalculationSvdForm
        metaData["workIds"] = getters.getSelectedWorks
        metaData['newSpw'] = getters.getTestCalculationSvdCheckbox.length > 0 ? 1 : 0
        delete metaData.contractRightsValues

        let response = await api.triggerAction(DIR, metaData, queryParams)
        if(response.error === -1) {
            commit('setTestCalculationSvdResult', response.response)
        } else {
            commit('setTestCalculationSvdResultErrorMessage', response.errorMsg)
        }        
    },

// Action: TEST CALCULATON C3

    // Fetch Sources from A-Z
    async fetchTestCalculationC3AzOfSource({ commit }) {
        let i = await api.getAzForMapping("import")
        const filteredList = i.list.filter(source => source.value !== 'erp-invoicing')
        commit('setTestCalculationC3SourceIdOptions', filteredList)
    },

    async fetchAutocompleteTestCalculationC3RecipientId({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setTestCalculationC3RecipientIdOptions', response.list)
    },

    async calculateC3TestCalculation({ getters, commit }) {
        let queryParams = {
            "action": "testCalculation",
            "type": "c3"
        }

        let metaData = {
            "workId": getters.getSelectedWorks[0],
            "amount": getters.getTestCalculationC3DetailsAmount,
            "collPercent": getters.getTestCalculationC3DetailsCollPercent,
            "country": getters.getTestCalculationC3DetailsCountry,
            "sourceId": getters.getTestCalculationC3DetailsSourceId,
            "rightsType": getters.getTestCalculationC3DetailsRightsTypes,
            "category": getters.getTestCalculationC3DetailsCategory,
            "subCategory": getters.getTestCalculationC3DetailsSubCategory,  
        }

        if (getters.getTestCalculationC3DetailsRecipientId) {
            metaData["recipientId"] = getters.getTestCalculationC3DetailsRecipientId.alvId
        } else {
            metaData["recipientId"] = null
        }

        let response = await api.triggerAction(DIR, metaData, queryParams)
        if(response.error === -1) {
            commit('setTestCalculationC3Result', response.response)
        } else {
            commit('setTestCalculationC3ResultErrorMessage', response.errorMsg)
        }        
    },

// Action: WORKS REGISTRATION
    async fetchCwrSocietiesList({ commit }) {
        let response = await api.getDropdownValues('account/credentials', 'getCwrSocietiesList')
        if (response && response.error === -1 && response.response && Array.isArray(response.response.list)) {
            commit('setCwrSocietiesList', response.response.list)
        } else {
            commit('setCwrSocietiesList', [])
        }
    },
    async workRegistrationLogin({ getters, commit}) {
        let metaData = {} 
        let queryParams = {"action": getters.getWorksRegistrationDetailsTarget + 'Login'}
        let loginResponse = await api.triggerAction(DIR, metaData, queryParams)

        if(loginResponse.error === 1) {
            commit('setWorksRegistrationDialogSuccessText', null)
            commit('setWorksRegistrationDialogErrorText', i18n.t(loginResponse.errorMsg))
            commit('setWorksRegistrationDialogDisableLoginButton', false)
        } else {
            commit('setWorksRegistrationGemaLoginToken', loginResponse.token)
            commit('setWorksRegistrationDialogErrorText', null)
            commit('setWorksRegistrationDialogStepText', i18n.t('lang_PUBLISHING_WORKS_WORK_REGISTRATION_STEP_2_OF_3'))
            commit('setWorksRegistrationDialogSuccessText', i18n.t('lang_PUBLISHING_WORKS_WORK_REGISTRATION_LOGIN_SUCCESSFUL'))
            commit('setWorksRegistrationDialogShowLoginButton', false)
            commit('setWorksRegistrationDialogShowPreflightButton', true)
        }
    },
    async workRegistrationPreflight({ getters, commit }) {
        let type = getters.getWorksRegistrationDetailsTarget
        let queryParams = { "action": type + 'Preflight' }
        let metaData = {
            "ids": getters.getSelectedWorks,
            "useAll": getters.getExportAllWorks, // New field to handle "all works from result set"
            "regionsInclude": [],
            "regionsExclude": [],
            "maestro": false,
            "includeWorksFromSubCWR": false,
            "noGhost": false,
            "noStatus2": false,
            "cwrMr100": (getters.getWorksRegistrationDetailsPmr == 'yes' ? true : false),
            "noPwrForOpu": false, // TODO_PT: noPwrForOpu for STIM/ICE registration?
            "exportNAT": false, // Export non-Latin work titles as NAT records
            "shareType" : getters.getWorksRegistrationDetailsShareType,
            "toBeRegisteredOnly": false,
            "exportWorksTypesCWR": "exportAllTypes",
            "cwrRecipient": getters.getWorksRegistrationDetailsCwrRecipient,
            "cwrFileVersion": "V22", // CWR version 2.2 hardcoded
            "collpercentCWR": getters.getWorksRegistrationDetailsInterestedParties,
            "submitter": getters.getWorksRegistrationDetailsCwrSubmitter,
            "token": getters.getWorksRegistrationGemaLoginToken,
            "selectedPublisher": getters.getWorksRegistrationDetailsSelectedPublisherEntry
        }

        let generateXmlResult = await api.triggerAction(DIR, metaData, queryParams)

        // TODO_XP: always return a single ZIP file and one attribute path, for GEMA, CWR... and all other use cases
        if(generateXmlResult.error === 1) {
            commit('setWorksRegistrationXmlFilePath', null)
            commit('setWorksRegistrationDialogSuccessText', null)
            let path = generateXmlResult.response.path
            commit('setWorksRegistrationPreflightPathCsv', path)
            commit('setWorksRegistrationDialogErrorText', i18n.t('lang_PUBLISHING_WORKS_WORK_REGISTRATION_VALIDATION_ERROR'))
            commit('setWorksRegistrationDialogDisablePreflightButton', false)
        } else {
            commit('setWorksRegistrationPreflightPathCsv', null)
            commit('setWorksRegistrationDialogErrorText', null)
            let path = generateXmlResult.response.path
            commit('setWorksRegistrationXmlFilePath', path)
            commit('setWorksRegistrationDialogStepText', i18n.t('lang_PUBLISHING_WORKS_WORK_REGISTRATION_STEP_3_OF_3'))
            commit('setWorksRegistrationDialogSuccessText', this._vm.$alvPlugin.buildParameterizedMessage(
                'lang_PUBLISHING_WORKS_WORK_REGISTRATION_VALIDATION_SUCCESS',
                {
                    exportedWorksCnt: generateXmlResult.response.totalExported,
                    totalWorksCnt: generateXmlResult.response.totalSelected 
                }
            ))
            commit('setWorksRegistrationDialogShowPreflightButton', false)
            commit('setWorksRegistrationDialogDisableSendButton', false)
            commit('setWorksRegistrationDialogShowSendButton', true)
            commit('setWorksRegistrationDeaktivateForm', true)
        }
    },
    async startWorksRegistration( { getters, commit }) {        
        let queryParams = { "action": getters.getWorksRegistrationDetailsTarget + 'Send' }
        let metaData = { "token": getters.getWorksRegistrationGemaLoginToken }

        let registerWorkResult = await api.triggerAction(DIR, metaData, queryParams)
        
        if(registerWorkResult.error === 1) {
            commit('setWorksRegistrationDialogSuccessText', null)
            commit('setWorksRegistrationXmlFilePath', null)

            let path = registerWorkResult.response.path
            commit('setWorksRegistrationRegistrationErrorCsv', path)
            commit('setWorksRegistrationDialogErrorText', i18n.t('lang_PUBLISHING_WORKS_WORK_REGISTRATION_SENDING_FAILED') )
            commit('setWorksRegistrationDialogDisableSendButton', false)
        } else {
            commit('setWorksRegistrationDialogErrorText', null)
            commit('setWorksRegistrationXmlFilePath', null)
            commit('setWorksRegistrationRegistrationErrorCsv', null)
            let path = registerWorkResult.response.path
            commit('setWorksRegistrationRegistrationCsv', path)
            commit('setWorksRegistrationDialogStepText', i18n.t('lang_PUBLISHING_WORKS_WORK_REGISTRATION_STEP_FINISHED'))
            commit('setWorksRegistrationDialogSuccessText', i18n.t('lang_GENERAL_CAPTION_ICON_DOWNLOAD') )
            commit('setWorksRegistrationDialogShowSendButton', false)
        }
    },

// Action: WORKS BULK EDITING - Convert ROLE% to INTL%
    async convertRoleToIntlShares( { getters, commit }) {

        let metaData = {}
        let queryParams = {
            "action" : "convertRole"
        }
        commit('setBulkEditingShowConvertRoleSharesProgressBar',true)

        // If the bulk editing was triggert by the "Bulk Editing" BUTTON and not the Bulk Editing ACTION
        // FE doesnt have any alvids, BE has to apply the editing on all works that are in the current list result
        // -> means, that could be ALL works or it will be just the works the user filtered/searched for.
        if(!getters.getBulkEditingAllWorks) metaData["alvIds"] = getters.getSelectedWorks

        // intl hardcoded because we limit role% > manu% > intl%
        metaData['type']                = "intl"
        metaData['target']              = "intl"
        metaData['societyOwn']          = getters.getWorksBulkEditingDetailsSocietyOwnShares
        metaData['combineCAAndE']       = getters.getWorksBulkEditingCombineCAAndECheckbox
        metaData['pmrCollects100MR']    = getters.getWorksBulkEditingPmrCollects100MRCheckbox
        metaData['bulkEditResultList']  = getters.getBulkEditingAllWorks

        // Debug logging for frontend


        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1){
            commit('setBulkEditConvertRoleToSharesReportCsv', response.response.path)
            commit('setBulkEditingShowConvertRoleSharesProgressBar',false)
        } else {
            // Handle potential errors from the API call itself, if necessary
            commit('setBulkEditingStatusOfConvertRoleShares', 'An error occurred during conversion.');
            commit('setBulkEditingShowConvertRoleSharesProgressBar',false)
        }
    },

    async copyShares( { getters, commit }) {
        let metaData = {}
        let queryParams = {
            "action" : "copyShares"
        }

        // If the bulk editing was triggert by the "Bulk Editing" BUTTON and not the Bulk Editing ACTION
        // FE doesnt have any alvids, BE has to apply the editing on all works that are in the current list result
        // -> means, that could be ALL works or it will be just the works the user filtered/searched for.
        if(!getters.getBulkEditingAllWorks) metaData["alvIds"] = getters.getSelectedWorks

        metaData['sourceShare'] = getters.getWorksBulkEditingDetailsSourceShare
        metaData['targetShare'] = getters.getWorksBulkEditingDetailsTargetShare
        metaData['bulkEditResultList']  = getters.getBulkEditingAllWorks

        let response = await api.triggerAction(DIR, metaData, queryParams)
        commit('setBulkEditCopySharesReportCsv', response.response.path)
        commit('setExpandedWorks',[])
    },

    async combineEShares( {getters, commit } ) {
        let metaData = {}
        let queryParams = {
            "action": "combineEShares"
        }
        
        // If the bulk editing was triggert by the "Bulk Editing" BUTTON and not the Bulk Editing ACTION
        // FE doesnt have any alvids, BE has to apply the editing on all works that are in the current list result
        // -> means, that could be ALL works or it will be just the works the user filtered/searched for.
        if (!getters.getBulkEditingAllWorks) metaData["alvIds"] = getters.getSelectedWorks

        metaData['targetShare'] = getters.getWorksBulkEditingDetailsTargetShareCombineE
        metaData['bulkEditResultList'] = getters.getBulkEditingAllWorks

        let response = await api.triggerAction(DIR, metaData, queryParams)
        commit('setExpandedWorks', [])
        commit('setWorksBulkEditingDetailsTargetShareCombineE', false)
    },
    
    async fillOriginalShares( { getters, commit }) {
        let metaData = {}
        let queryParams = {
            "action" : "fillIntl"
        }
        
        // If the bulk editing was triggert by the "Bulk Editing" BUTTON and not the Bulk Editing ACTION
        // FE doesnt have any alvids, BE has to apply the editing on all works that are in the current list result
        // -> means, that could be ALL works or it will be just the works the user filtered/searched for.
        if(!getters.getBulkEditingAllWorks) metaData["alvIds"] = getters.getSelectedWorks

        metaData['sourceShare'] = getters.getWorksBulkEditingDetailsSourceShare
        metaData['targetShare'] = getters.getWorksBulkEditingDetailsFillOriginalShares
        metaData['copyMrToPr'] = getters.getWorksBulkEditingCopyMrToPrCheckbox
        metaData['bulkEditResultList']  = getters.getBulkEditingAllWorks

        let response = await api.triggerAction(DIR, metaData, queryParams)
        commit('setBulkEditFillOriginalSharesFailedCount', response.response.failedCount || 0)
        commit('setBulkEditFillOriginalSharesReportCsv', response.response.path)
    },

    // TODO_PT: Work in Progress
    // identify SE
    // delete SE and UVZ of SE to E
    // copy shares to representing E
    async removeSE( { getters, commit }) {
        let metaData = {}
        let queryParams = {
            "action" : "removeSE"
        }
        // If the bulk editing was triggert by the "Bulk Editing" BUTTON and not the Bulk Editing ACTION
        // FE doesnt have any alvids, BE has to apply the editing on all works that are in the current list result
        // -> means, that could be ALL works or it will be just the works the user filtered/searched for.
        if(!getters.getBulkEditingAllWorks) metaData["alvIds"] = getters.getSelectedWorks

        metaData['partySE']     = getters.getWorksBulkEditingDetailsRemoveSEField
        metaData['shareType']   = getters.getWorksBulkEditingDetailsRemoveSEShareType
        metaData['bulkEditResultList']  = getters.getBulkEditingAllWorks

        let response = await api.triggerAction(DIR, metaData, queryParams)
        commit('setBulkEditRemoveSEReportCsv', response.response.path)
    },

// Action: EXPORT works
    async exportWorks( { getters, commit }) {
        let type = getters.getExportWorksDetailsType
        // combine both checkbox arrays, for Excel and for CWR, into a single array
        let checkboxes = getters.getExportWorksExcelCheckbox.concat(getters.getExportWorksCWRCheckbox)
        let metaData = {}
        let queryParams = {
            "action" : "export",
            "type" : type.toLowerCase()
        }

        // Attributes for both types (Excel + CWR), check if 'keystrings' are in array => true
        metaData["collpercent"+type]            = getters['getExportWorksDetailsInterestedParties'+type]
        metaData["includeWorksFromSub"+type]    = checkboxes.includes("includeWorksFromSub"+type) ? true : false
        metaData["smartIntl"+type]              = checkboxes.includes("smartIntl"+type) ? true : false
        metaData["exportWorksTypes"+type]       = getters['getExportWorksDetailsExportWorksTypes'+type]
        metaData["pseudoSlg"]                   = getters.getExportWorksDetailsPseudoSlg
        metaData['shareType']                   = getters.getExportWorksDetailsShareType // unify INTL/OWN share type selector for Excel and CWR export
        
        if(type === 'Excel') {
            metaData["singleRow"]               = checkboxes.includes("singleRow") ? true : false
            metaData["germanCaptions"]          = checkboxes.includes("germanCaptions") ? true : false
        } 
        
        else if(type === 'CWR') {
            metaData["maestro"]                 = checkboxes.includes("maestro") ? true : false
            metaData["noGhost"]                 = checkboxes.includes("noGhost") ? true : false
            metaData["noStatus2"]               = checkboxes.includes("noStatus2") ? true : false
            metaData["cwrMr100"]                = checkboxes.includes("cwrMr100") ? true : false
            metaData["noPwrForOpu"]             = checkboxes.includes("noPwrForOpu") ? true : false
            metaData["exportNAT"]               = checkboxes.includes("exportNAT") ? true : false
            metaData["splitCopubWriters"]       = checkboxes.includes("splitCopubWriters") ? true : false
            metaData["toBeRegisteredOnly"]      = checkboxes.includes("toBeRegisteredOnly") ? true : false
            metaData["cwrRecipient"]            = getters.getExportWorksDetailsCwrRecipient
            metaData["submitter"]               = getters.getExportWorksDetailsCwrSubmitter
            metaData["cwrFileVersion"]          = getters.getExportWorksDetailsCwrFileVersion
            metaData['selectedPublisher']       = getters.getExportWorksDetailsSelectedPublisherEntry

            if (getters.getExportWorksDetailsCwrFileVersion === 'CWR-JSON') {
                metaData.schema = getters.getExportWorksDetailsSchema
            }

            // Regions
            let metaDataIncludes = []
            let includes = getters.getExportWorksDetailsInclude
            for(let i = 0; i < includes.length; i++) { 
                metaDataIncludes.push(includes[i]) 
            }
            metaData['regionsInclude'] = metaDataIncludes
            
            let metaDataExcludes = []
            let excludes = getters.getExportWorksDetailsExclude
            for(let i = 0; i < excludes.length; i++) { 
                metaDataExcludes.push(excludes[i]) 
            }
            metaData['regionsExclude'] = metaDataExcludes 
        }
        else if (type === 'JWR') {
            metaData["submitter"] = getters.getExportWorksDetailsJwrSubmitter
        }
        else if (type == 'mappings') {
            metaData['mappingId'] = getters.getExportWorksDetailsMappingId
            metaData['mappingSource'] = getters.getExportWorksDetailsMappingSource
        }

        // If the "exportAllWorks" is false add the selected works from the list
        if(!getters.getExportAllWorks) {
            metaData["workIds"] = getters.getSelectedWorks
        }
        commit('setIsLoading', true)
        
        let response = await api.triggerAction(DIR, metaData, queryParams)
        if(response.response.path !== null) commit('setExportWorksResultLink', response.response.path)
        if(response.response.gi !== null) commit('setExportWorksResultGi', response.response.gi)
        commit('setExportWorksHasError', response.error === 1)

        if(response.error === 1) {  
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                // "No works exported" is a soft outcome (logfile explains per-work reasons),
                // so show it as an orange warning instead of a red error.
                let isNoWorksExported = errorMsg === 'lang_PUBLISHING_WORKS_MESSAGE_WARNING_NO_WORKS_EXPORTED'
                commit('setSnackbar', {
                    type: isNoWorksExported ? 'warning' : 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            } else {
                commit('setExportWorksErrorArray', response.response.error)
                commit('setExportWorksShowResult', true)
            }
        } else {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_DOWNLOAD_FILE_NOW')
            })
        }
        commit('setIsLoading', false)
    },
    // Autocomplete fields for CWR Works Export
    async fetchAutocompleteExportWorksInclude({ commit }, input) {
        let items = await api.getRegion(input, i18n.locale)
        commit('setExportWorksIncludeOptions', items)
    },
    async fetchAutocompleteExportWorksExclude({ commit }, input) {
        let items = await api.getRegion(input, i18n.locale)
        commit('setExportWorksExcludeOptions', items)
    },
    async fetchAutocompleteWorksImportCwrJsonInclude({ commit }, input) {
        let items = await api.getRegion(input, i18n.locale)
        commit('setWorksImportCwrJsonIncludeOptions', items)
    },
    async fetchAutocompleteWorksImportCwrJsonExclude({ commit }, input) {
        let items = await api.getRegion(input, i18n.locale)
        commit('setWorksImportCwrJsonExcludeOptions', items)
    },

// Action: COPY work
    async copyWork({ getters, commit, dispatch }) {
        let queryParams = { "action": "copy" }
        let metaData = { "alvIds": getters.getSelectedWorks }

        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_COPY_SUCCESSFULL')
            })
            dispatch('fetchWorks')
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
    },

    async fetchCwrSubmitterCode({ getters, commit, dispatch }) {
        let id = getters.getSelectedPublishingCompanyId
        if (id > 0) {
            let companyObject = await api.getCompanyObject('account/companies/publishing/', id)
            commit('setSelectedCwrSubmitterCode', companyObject.cwrSubmitterCode)
            commit('setSelectedSpotifySetting', companyObject.spotify)
        }
	},
    setDefaultPublishingCompany({ getters, commit, dispatch }){
        if(getters.getPublishingCompanies.length !== 0) {
            let userData = JSON.parse(localStorage.getItem('userData'))
            if(getters.getSelectedPublishingCompany === ''){
                let selectedPublishingCompany = userData.selectedPublishingCompanyId
                let match = getters.getPublishingCompanies.find(company =>
                    company.id === selectedPublishingCompany
                ).name
                commit('setSelectedPublishingCompany', match)
            }
        }
    }
}
export default { state, getters, actions, mutations }